(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-box"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__buyBoxInit) return;
    window.__buyBoxInit = true;

    var STRINGS = window.__buyBoxStrings || {};
    var ROUTES = window.__buyBoxRoutes || {};
    var states = new WeakMap();

    function getData(box) {
      var s = states.get(box);
      if (s) return s;

      var dataEl = box.querySelector('[data-buy-box-data]');
      var variants = [];
      try {
        variants = JSON.parse(dataEl ? dataEl.textContent : '[]');
      } catch (err) {
        variants = [];
      }

      var input = box.querySelector('[data-buy-box-variant-input]');
      var current = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(input ? input.value : '')) current = variants[i];
      }
      if (!current && variants.length) current = variants[0];

      var soldOut = {};
      variants.forEach(function (v) {
        v.options.forEach(function (val, gi) {
          soldOut[gi] = soldOut[gi] || {};
          if (v.available) soldOut[gi][val] = false;
          else if (soldOut[gi][val] === undefined) soldOut[gi][val] = true;
        });
      });

      s = {
        variants: variants,
        current: current,
        selected: current ? current.options.slice() : [],
        soldOut: soldOut
      };
      states.set(box, s);
      return s;
    }

    function isSale(v) {
      return Boolean(v.compare && v.compare > v.price);
    }

    /* Matches the Liquid money filter's "$1,234.56" shape from cents. */
    function formatMoney(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    /* ATC label = template x (unit price x stepper qty). qty 1 keeps the
       server-formatted price_money verbatim (flags 53). The strings are
       read LIVE off window at call time - the bundle boots before the
       inline __buyBoxStrings script, so the IIFE-captured STRINGS var is
       frozen empty; when even the live read misses, the template derives
       once from the pristine server-rendered label. */
    function updateAtcLabel(box) {
      if (box.getAttribute('data-gift') === 'true') return;
      var s = getData(box);
      if (!s.current) return;
      var atcLabel = box.querySelector('[data-buy-box-atc] .button__label');
      if (!atcLabel) return;
      var live = window.__buyBoxStrings || {};
      var tradeEx = box.getAttribute('data-trade-ex') === 'true';
      var tpl = tradeEx ? live.atcExGst || STRINGS.atcExGst : live.atc || STRINGS.atc;
      if (!tpl) {
        var shown = tradeEx && s.current.trade_price_money ? s.current.trade_price_money : s.current.price_money;
        if (!s.__atcTpl && atcLabel.textContent.indexOf(shown) !== -1) {
          s.__atcTpl = atcLabel.textContent.replace(shown, '__AMOUNT__');
        }
        tpl = s.__atcTpl;
      }
      if (!tpl) return;
      var qtyInput = box.querySelector('[data-stepper-input]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var amount = qty > 1 ? formatMoney(s.current.price * qty) : s.current.price_money;
      if (tradeEx && typeof s.current.trade_price === 'number') {
        amount = qty > 1 ? formatMoney(s.current.trade_price * qty) : s.current.trade_price_money;
      }
      atcLabel.textContent = String(tpl).replace('__AMOUNT__', amount);
    }

    document.addEventListener('quantity:change', function (event) {
      var box = event.target && event.target.closest ? event.target.closest('[data-buy-box]') : null;
      if (box) updateAtcLabel(box);
    });

    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || !t.matches || !t.matches('[data-stepper-input]')) return;
      var box = t.closest('[data-buy-box]');
      if (box) updateAtcLabel(box);
    });

    function applyVariant(box, v) {
      var s = getData(box);
      s.current = v;
      s.selected = v.options.slice();

      var input = box.querySelector('[data-buy-box-variant-input]');
      if (input) input.value = v.id;

      var priceEl = box.querySelector('[data-price]');
      var gift = box.getAttribute('data-gift') === 'true';
      var trade = box.getAttribute('data-trade') === 'true';
      if (priceEl && !gift) {
        var current = priceEl.querySelector('.price__current');
        if (current) current.textContent = trade && v.trade_money ? v.trade_money : v.price_money;

        /* Trade row: the ex-GST "+ GST" price updates above; the TRADE
           badge, plain RRP (product-level custom.rrp) and trade note are
           variant-independent. */
        if (!trade) {
          var sale = isSale(v);
          var compare = priceEl.querySelector('.price__compare');
          if (sale) {
            if (!compare) {
              compare = document.createElement('s');
              compare.className = 'price__compare';
              priceEl.appendChild(compare);
            }
            compare.textContent = '';
            var sr = document.createElement('span');
            sr.className = 'price__sr';
            sr.textContent = STRINGS.regularPrice || '';
            compare.appendChild(sr);
            compare.appendChild(document.createTextNode(v.compare_money));
          } else if (compare) {
            compare.remove();
          }
          priceEl.classList.toggle('price--sale', sale);
          priceEl.classList.toggle('price--muted', box.getAttribute('data-all-oos') === 'true');
        }
      }

      /* Price-in-label ATC (checklist 14): computed from the variant
         payload, never typed. Multiplied by the stepper quantity
         (Brendon 2026-09-07, flags 53). */
      if (!gift) updateAtcLabel(box);

      /* Ticket 20374531 (#113): Afterpay amount = the selected variant's
         price in dollars (the library's own price / 100 shape); its
         mutation observer picks the new text up. The library hides the
         placement inline when the page loads on a sold-out variant, so the
         inline display is cleared here and the sold-out rule in the
         stylesheet decides visibility instead. */
      var afterpayAmount = box.querySelector('[data-afterpay-product]');
      if (afterpayAmount) {
        afterpayAmount.textContent = String(v.price / 100);
        var afterpayPlacement = afterpayAmount.nextElementSibling;
        if (afterpayPlacement && afterpayPlacement.tagName === 'SQUARE-PLACEMENT') {
          afterpayPlacement.style.removeProperty('display');
        }
      }

      /* Status label and low-stock message are mutually exclusive: the status
         label hides whenever the low-stock message shows (ticket 147). */
      var isLow = Boolean(v.low_stock_label);

      var lowStock = box.querySelector('[data-buy-box-low-stock]');
      if (lowStock) {
        lowStock.hidden = !isLow;
        lowStock.textContent = v.low_stock_label || '';
      }

      var stock = box.querySelector('[data-buy-box-stock]');
      if (stock) {
        stock.hidden = isLow;
        if (v.stock_label) stock.textContent = v.stock_label;
      }

      var help = box.querySelector('[data-buy-box-help]');
      if (help) {
        help.hidden = !v.help_label;
        var helpText = help.querySelector('[data-buy-box-help-text]');
        if (helpText) helpText.textContent = v.help_label || '';
      }

      box.querySelectorAll('[data-buy-box-echo]').forEach(function (el) {
        el.textContent = v.options[el.dataset.group] || '';
      });

      box.querySelectorAll('[data-buy-box-pill]').forEach(function (pill) {
        var gi = pill.dataset.group;
        var val = pill.dataset.value;
        var sold = Boolean(s.soldOut[gi] && s.soldOut[gi][val]);
        var sel = v.options[gi] === val;
        pill.classList.toggle('pill--selected', sel);
        pill.classList.toggle('pill--sold-out', sold);
        pill.setAttribute('aria-pressed', sel ? 'true' : 'false');
        if (sold) pill.setAttribute('aria-disabled', 'true');
        else pill.removeAttribute('aria-disabled');
      });

      var stepperInput = box.querySelector('[data-stepper-input]');
      if (stepperInput) {
        if (v.max) stepperInput.setAttribute('max', v.max);
        else stepperInput.removeAttribute('max');
      }

      var formWrap = box.querySelector('[data-buy-box-form-wrap]');
      if (formWrap) formWrap.hidden = gift ? false : !v.available;
      var soldOutBlock = box.querySelector('[data-buy-box-sold-out]');
      if (soldOutBlock) soldOutBlock.hidden = gift ? true : Boolean(v.available);
      var oosWrap = box.querySelector('[data-buy-box-oos]');
      if (oosWrap) oosWrap.hidden = gift ? true : Boolean(v.available);

      var notify = box.querySelector('[data-notify-me]');
      if (notify) notify.setAttribute('data-variant-id', v.id);

      var rootState = 'default';
      if (!gift) {
        if (!v.available) rootState = 'sold-out';
        else if (isSale(v)) rootState = 'sale';
      }
      box.setAttribute('data-state', rootState);

      document.dispatchEvent(
        new CustomEvent('product:variant-change', {
          detail: {
            variant_id: v.id,
            price: v.price,
            compare_at_price: v.compare,
            available: v.available,
            inventory: v.inventory
          }
        })
      );
    }

    document.addEventListener('click', function (event) {
      var rating = event.target.closest('[data-buy-box-rating]');
      if (rating) {
        event.preventDefault();
        var target = document.getElementById('pdp-reviews');
        if (target) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
        return;
      }

      var pill = event.target.closest('[data-buy-box-pill]');
      if (!pill) return;
      var box = pill.closest('[data-buy-box]');
      if (!box || pill.getAttribute('aria-disabled') === 'true') return;

      var s = getData(box);
      var gi = Number(pill.dataset.group);
      s.selected[gi] = pill.dataset.value;

      var match = null;
      for (var i = 0; i < s.variants.length; i++) {
        var cand = s.variants[i];
        var ok = true;
        for (var j = 0; j < s.selected.length; j++) {
          if (cand.options[j] !== s.selected[j]) {
            ok = false;
            break;
          }
        }
        if (ok) {
          match = cand;
          break;
        }
      }
      if (match) applyVariant(box, match);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form.buy-box__form');
      if (!form || form.hidden) return;
      var wrap = form.closest('[data-buy-box-form-wrap]');
      if (wrap && wrap.hidden) return;
      event.preventDefault();

      var btn = form.querySelector('[data-buy-box-atc]');
      if (btn) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
      }

      var body = new URLSearchParams(new FormData(form));
      fetch(ROUTES.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: body
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          }
          document.dispatchEvent(
            new CustomEvent('cart:item-added', {
              detail: { variant_id: body.get('id'), quantity: Number(body.get('quantity') || 1) }
            })
          );
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { invoker: btn } }));
        })
        .catch(function () {
          form.submit();
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy-them-together"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bttInit) return;
    window.__bttInit = true;

    var ROUTES = window.__bttRoutes || {};

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-btt-form]');
      if (!form) return;
      event.preventDefault();

      var button = form.querySelector('[data-btt-add]');
      if (!button || button.classList.contains('is-loading')) return;

      var payload = {};
      try {
        payload = JSON.parse(form.querySelector('[data-btt-payload]').textContent);
      } catch (err) {
        payload = {};
      }

      var mainId = payload.mainVariantId;
      var pairId = payload.pairVariantId;
      var items = [];
      if (mainId) items.push({ id: mainId, quantity: 1 });
      if (pairId && String(pairId) !== String(mainId)) items.push({ id: pairId, quantity: 1 });
      if (!items.length) return;

      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      fetch(payload.cartAdd || ROUTES.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { invoker: button } }));
        })
        .catch(function () {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          form.submit();
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-addons"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cartAddons) return;
    window.__cartAddons = true;

    var ADDED_MS = 600;

    function markLoading(button, busy) {
      if (busy) {
        button.setAttribute('data-loading', '');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      } else {
        button.removeAttribute('data-loading');
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest
        ? event.target.closest('[data-cart-addons-add]')
        : null;
      if (!trigger || trigger.disabled) return;
      if (trigger.hasAttribute('data-loading')) return;
      event.preventDefault();

      var variantId = trigger.getAttribute('data-variant-id');
      if (!variantId) return;

      markLoading(trigger, true);

      var body = { id: variantId, quantity: 1 };
      var sectionEl = trigger.closest('.shopify-section');
      if (sectionEl && sectionEl.id) {
        body.sections = [sectionEl.id.replace(/^shopify-section-/, '')];
      }

      var routes = window.__cartAddonsRoutes || {};
      fetch((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function (cart) {
          markLoading(trigger, false);
          trigger.setAttribute('data-added', '');
          window.setTimeout(function () {
            trigger.removeAttribute('data-added');
          }, ADDED_MS);
          /* cart:updated only - never cart:add. On the cart template the
             page IS the cart surface: the strip must not open the flyout
             (scope brief section 6), so the host section re-renders in
             place on this event instead. */
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart: cart,
                sections: (cart && cart.sections) || null,
                source: 'cart-addons'
              }
            })
          );
        })
        .catch(function () {
          markLoading(trigger, false);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-flyout"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cart-flyout')) return;

    var TRANSITION_MS = 200;

    function routes() {
      return window.__cartFlyoutRoutes || {};
    }

    customElements.define(
      'cart-flyout',
      class CartFlyout extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.panel = this.querySelector('.cart-flyout__panel');
          this.body = this.querySelector('[data-cart-body]');
          this.__invoker = null;
          this.__pendingQuantity = new Map();
          this.__onChange = this.__dispatchChange.bind(this);
          this.__onClick = this.__handleClick.bind(this);
          this.__onKeydown = this.__handleKeydown.bind(this);
          this.__onScrim = this.close.bind(this, false);
          this.__onCartAdd = this.__handleCartAdd.bind(this);
          this.__onFocusIn = this.__trapFocus.bind(this);
          this.addEventListener('change', this.__onChange);
          this.addEventListener('quantity:change', this.__onChange);
          this.addEventListener('focusin', this.__onFocusIn);
          document.addEventListener('click', this.__onClick);
          document.addEventListener('keydown', this.__onKeydown);
          document.addEventListener('scrim:click', this.__onScrim);
          document.addEventListener('cart:add', this.__onCartAdd);
          /* Overlay exclusivity is symmetric (stage-7 sweep latent
             finding): another overlay opening closes this flyout, exactly
             as this flyout's own open() closes the others. */
          document.addEventListener('drawer:open', this.__onScrim);
          document.addEventListener('search:open', this.__onScrim);
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          this.removeEventListener('change', this.__onChange);
          this.removeEventListener('quantity:change', this.__onChange);
          this.removeEventListener('focusin', this.__onFocusIn);
          document.removeEventListener('click', this.__onClick);
          document.removeEventListener('keydown', this.__onKeydown);
          document.removeEventListener('scrim:click', this.__onScrim);
          document.removeEventListener('cart:add', this.__onCartAdd);
          document.removeEventListener('drawer:open', this.__onScrim);
          document.removeEventListener('search:open', this.__onScrim);
        }

        get isOpen() {
          return this.classList.contains('is-open');
        }

        open(invoker) {
          if (this.isOpen) return;
          if (invoker) this.__invoker = invoker;
          this.classList.remove('is-closing');
          this.setAttribute('aria-hidden', 'false');
          this.__scrollLock(true);
          this.__showScrim();
          requestAnimationFrame(() => {
            this.classList.add('is-open');
            /* Focus must land after is-open flips visibility - focus() silently
               no-ops on a visibility:hidden panel, leaving focus on body. */
            this.__focusPanel();
          });
          this.__closeOtherOverlays();
          document.dispatchEvent(new CustomEvent('cart:open'));
        }

        close(returnFocus) {
          if (!this.isOpen) return;
          this.classList.remove('is-open');
          this.classList.add('is-closing');
          this.setAttribute('aria-hidden', 'true');
          this.__scrollLock(false);
          this.__hideScrim();
          window.setTimeout(() => {
            if (!this.isOpen) this.classList.remove('is-closing');
          }, TRANSITION_MS);
          document.dispatchEvent(new CustomEvent('cart:close'));
          if (returnFocus !== false && this.__invoker && typeof this.__invoker.focus === 'function') {
            this.__invoker.focus();
            this.__invoker = null;
          }
        }

        refresh() {
          var root = this;
          var sectionId = window.__cartFlyoutSectionId;
          var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          if (sectionId) {
            url = url + '?sections=' + encodeURIComponent(sectionId);
            return fetch(url)
              .then((response) => response.json())
              .then((data) => {
                var html = data && data[sectionId];
                if (!html) return;
                var tpl = document.createElement('template');
                tpl.innerHTML = html.trim();
                var fresh = tpl.content.querySelector('cart-flyout');
                if (fresh && root.parentNode) root.parentNode.replaceChild(fresh, root);
              })
              .catch(() => {});
          }
          return fetch(url)
            .then((response) => response.text())
            .then((html) => {
              var tpl = document.createElement('template');
              tpl.innerHTML = html;
              var fresh = tpl.content.querySelector('cart-flyout[data-cart-flyout]');
              if (!fresh) return;
              /* Keep the live element (open state, listeners) and swap only
                 the rendered content regions - header count, progress strip
                 and body (items + empty + summary figures). */
              var freshCount = fresh.querySelector('[data-cart-count]');
              var count = root.querySelector('[data-cart-count]');
              if (freshCount && count) count.textContent = freshCount.textContent;
              var freshProgress = fresh.querySelector('[data-cart-progress]');
              var progress = root.querySelector('[data-cart-progress]');
              if (freshProgress && progress) progress.innerHTML = freshProgress.innerHTML;
              var freshBody = fresh.querySelector('[data-cart-body]');
              var body = root.querySelector('[data-cart-body]');
              if (freshBody && body) {
                body.innerHTML = freshBody.innerHTML;
                root.__rebindBody();
              }
              var wasEmpty = root.classList.contains('is-empty');
              var isEmpty = fresh.classList.contains('is-empty');
              if (isEmpty !== wasEmpty) root.classList.toggle('is-empty', isEmpty);
            })
            .catch(() => {});
        }

        __rebindBody() {
          // Body content re-renders through region swaps; the quantity-stepper
          // custom element re-upgrades automatically inside the replaced HTML
          // (custom element upgrade on re-connect), and this element's own
          // listeners are bound on the root + document - both stable across
          // the swap.
        }

        __focusPanel() {
          if (this.panel && typeof this.panel.focus === 'function') this.panel.focus();
        }

        __trapFocus(event) {
          var list = this.__visibleFocusables();
          if (!list.length) return;
          if (!this.contains(document.activeElement)) {
            list[0].focus();
            return;
          }
          if (this.__lastTabFromLast && document.activeElement === list[list.length - 1]) {
            list[0].focus();
          }
          this.__lastTabFromLast = document.activeElement === list[list.length - 1];
        }

        __visibleFocusables() {
          var focusables = this.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          /* offsetParent is non-null under visibility:hidden, so display:none
             breakpoint controls (the desktop bin at mobile, the mobile text
             Remove and View bag at desktop) are filtered out here - the trap
             must only ever land on genuinely visible controls. */
          return Array.prototype.filter.call(focusables, (el) => {
            if (el.offsetParent === null) return false;
            var node = el;
            while (node && node !== this) {
              if (node.hasAttribute && (node.hasAttribute('hidden') || getComputedStyle(node).visibility === 'hidden')) return false;
              node = node.parentNode;
            }
            return true;
          });
        }

        __handleKeydown(event) {
          if (!this.isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (event.key !== 'Tab') return;
          var list = this.__visibleFocusables();
          if (!list.length) return;
          var first = list[0];
          var last = list[list.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        __handleClick(event) {
          var target = event.target;
          if (!target || !target.closest) return;
          var opener = target.closest('[data-cart-open]');
          if (opener) {
            event.preventDefault();
            this.open(opener);
            return;
          }
          if (!this.isOpen) return;
          if (target.closest('[data-cart-close]')) {
            this.close();
            return;
          }
          var remove = target.closest('[data-cart-remove]');
          if (remove) {
            this.__removeLine(remove.closest('[data-cart-line]'));
            return;
          }
        }

        __handleCartAdd(event) {
          var detail = (event && event.detail) || {};
          this.refresh().then(() => {
            this.open(detail.invoker || null);
            /* Adds come from surfaces (buy-box, card overlay) that don't
               publish cart:updated themselves -- publish it here so the header bag
               badge and cart page hear every add (engineer-reported). */
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            return fetch(root + 'cart.js')
              .then((r) => r.json())
              .then((cart) => {
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'cart-flyout-add' } }));
              })
              .catch(() => {});
          });
        }

        __dispatchChange(event) {
          var line = event.target.closest ? event.target.closest('[data-cart-line]') : null;
          if (!line) return;
          var stepper = event.target.closest('[data-quantity-stepper]');
          if (!stepper) return;
          var input = stepper.querySelector('[data-stepper-input]');
          if (!input) return;
          var key = line.getAttribute('data-line-key');
          this.__queueQuantity(key, parseInt(input.value, 10));
        }

        __queueQuantity(key, quantity) {
          if (!key || Number.isNaN(quantity)) return;
          var previous = this.__pendingQuantity.get(key);
          if (previous) window.clearTimeout(previous.timer);
          var line = this.querySelector('[data-line-key="' + key + '"]');
          var timer = window.setTimeout(() => {
            this.__pendingQuantity.delete(key);
            this.__changeLine(key, quantity, line);
          }, 220);
          this.__pendingQuantity.set(key, { timer: timer });
          if (line) line.setAttribute('data-busy', '');
        }

        __changeLine(key, quantity, line) {
          var body = new URLSearchParams();
          body.append('id', key);
          body.append('quantity', String(quantity));
          var sectionId = window.__cartFlyoutSectionId;
          if (sectionId) body.append('sections', sectionId);
          fetch(routes().cartChange || '/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
          })
            .then((response) => response.json())
            .then((cart) => {
              if (line) line.removeAttribute('data-busy');
              this.__applyCart(cart, sectionId);
            })
            .catch(() => {
              if (line) line.removeAttribute('data-busy');
            });
        }

        __removeLine(line) {
          if (!line) return;
          var key = line.getAttribute('data-line-key');
          var body = new URLSearchParams();
          body.append('id', key);
          body.append('quantity', '0');
          var sectionId = window.__cartFlyoutSectionId;
          if (sectionId) body.append('sections', sectionId);
          line.setAttribute('data-busy', '');
          fetch(routes().cartChange || '/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
          })
            .then((response) => response.json())
            .then((cart) => this.__applyCart(cart, sectionId))
            .catch(() => line.removeAttribute('data-busy'));
        }

        __applyCart(cart, sectionId) {
          if (cart && typeof cart.item_count !== 'undefined') {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          }
          /* Bundled section rendering: when the mutation payload carried
             `sections`, the re-rendered flyout HTML comes back inside the
             cart response itself (one round-trip, no follow-up fetch). */
          if (cart && cart.sections && sectionId && cart.sections[sectionId]) {
            var tpl = document.createElement('template');
            tpl.innerHTML = cart.sections[sectionId].trim();
            var fresh = tpl.content.querySelector('cart-flyout');
            if (fresh && this.parentNode) {
              this.parentNode.replaceChild(fresh, this);
              if (this.isOpen) fresh.open(null);
              return;
            }
          }
          this.refresh();
        }

        __scrollLock(locked) {
          document.documentElement.style.overflow = locked ? 'hidden' : '';
          document.body.style.overflow = locked ? 'hidden' : '';
        }

        __showScrim() {
          var scrim = document.querySelector('[data-scrim]');
          if (!scrim) return;
          scrim.style.setProperty('--scrim-top', '0px');
          /* Above the header (z 40): the flyout is a full-height modal, so the
             header dims with the rest of the page. It stays below the panel
             (z 50) - engineer-reported: header stayed bright behind the scrim. */
          scrim.style.setProperty('--scrim-z', '45');
          scrim.classList.add('is-open');
        }

        __hideScrim() {
          var scrim = document.querySelector('[data-scrim]');
          if (!scrim) return;
          scrim.classList.remove('is-open');
          scrim.style.removeProperty('--scrim-top');
          scrim.style.removeProperty('--scrim-z');
        }

        __closeOtherOverlays() {
          document.dispatchEvent(new CustomEvent('header:cart:open'));
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-line-item"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cartLineItem) return;
    window.__cartLineItem = true;

    var timers = new WeakMap();
    var queues = new WeakMap();

    function rowOf(node) {
      return node.closest ? node.closest('[data-cart-line-item]') : null;
    }

    function setBusy(row, busy) {
      if (busy) {
        row.setAttribute('data-loading', '');
        row.setAttribute('aria-busy', 'true');
      } else {
        row.removeAttribute('data-loading');
        row.removeAttribute('aria-busy');
      }
      var stepper = row.querySelector('[data-quantity-stepper]');
      if (stepper) {
        if (busy) {
          stepper.setAttribute('data-busy', '');
        } else {
          stepper.removeAttribute('data-busy');
        }
      }
      var remove = row.querySelector('[data-cart-line-item-remove]');
      if (remove) remove.disabled = busy;
    }

    function request(row, quantity) {
      var queue = queues.get(row) || Promise.resolve();
      var run = queue
        .then(function () {
          return send(row, quantity);
        })
        .catch(function () {
          setBusy(row, false);
          var form = row.closest('form');
          if (form) form.submit();
        });
      queues.set(row, run);
      return run;
    }

    function send(row, quantity) {
      setBusy(row, true);
      var config = window.__cartLineItemConfig || {};
      var url = (config.cartChangeUrl || '/cart/change') + '.js';
      var body = { id: row.getAttribute('data-line-key'), quantity: quantity };
      var sectionEl = row.closest('.shopify-section');
      if (sectionEl && sectionEl.id) {
        body.sections = [sectionEl.id.replace(/^shopify-section-/, '')];
      }
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart change failed');
          return res.json();
        })
        .then(function (data) {
          setBusy(row, false);
          row.setAttribute('data-line-quantity', String(quantity));
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart: data,
                sections: data.sections || null,
                source: 'cart-line-item'
              }
            })
          );
        })
        .catch(function (err) {
          setBusy(row, false);
          throw err;
        });
    }

    document.addEventListener('quantity:change', function (event) {
      var row = rowOf(event.target);
      if (!row) return;
      var value =
        event.detail && typeof event.detail.value === 'number'
          ? event.detail.value
          : parseInt(event.target.value, 10);
      clearTimeout(timers.get(row));
      timers.set(
        row,
        setTimeout(function () {
          request(row, value);
        }, 250)
      );
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest
        ? event.target.closest('[data-cart-line-item-remove]')
        : null;
      if (!trigger) return;
      event.preventDefault();
      var row = rowOf(trigger);
      if (!row || trigger.disabled) return;
      request(row, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-demo-az-jump-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    // Demo-only: mirror the active-letter contract the host directory's
    // IntersectionObserver owns. Sets .is-active + aria-current="true" on
    // the K link of the last rendered az-jump-bar on this page.
    // JS strings note: no user-facing copy here, so no window.__ strings
    // injection is required (Modern JS rule 6 covers literal UI English).
    function init() {
      var bars = document.querySelectorAll('[data-az-jump-bar]');
      var bar = bars[bars.length - 1];
      if (!bar || bar.dataset.azDemoActive === 'true') return;
      bar.dataset.azDemoActive = 'true';
      var link = bar.querySelector('[data-az-letter="K"]');
      if (!link) return;
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'true');
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-demo-page-toc"] && !Shopify.designMode) return;
  try {
    /* Populate both demo specimens from the inline JSON list above (the
     privacy-policy section set the boards draw), then force the first link
     active so the fx6TH reference state renders statically for QA. */
  (function () {
    function initDemo() {
      var dataEl = document.querySelector('script[data-page-toc-demo-data]');
      if (!dataEl) return;
      var headings;
      try {
        headings = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      var prose = document.querySelector('.ds-page-toc-demo-prose');
      if (!prose) {
        prose = document.createElement('div');
        prose.className = 'ds-page-toc-demo-prose';
        prose.setAttribute('aria-hidden', 'true');
        prose.style.display = 'none';
        headings.forEach(function (text) {
          var h = document.createElement('h2');
          h.textContent = text;
          prose.appendChild(h);
        });
        var demo = document.querySelector('.ds-page-toc-demo');
        if (!demo) return;
        demo.appendChild(prose);
      }

      document.querySelectorAll('[data-page-toc-demo]').forEach(function (el) {
        el.setAttribute('data-page-toc-content-selector', '.ds-page-toc-demo-prose');
        if (typeof el.build === 'function') {
          el.build();
        }
      });

      var first = document.querySelector('.ds-page-toc-demo-desktop .page-toc__link');
      if (first) {
        first.classList.add('page-toc__link--active');
        first.setAttribute('aria-current', 'true');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDemo);
    } else {
      initDemo();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-demo-scrim"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__dsScrimDemo) return;
    window.__dsScrimDemo = true;

    var PANEL_BOTTOM = 240;

    function setStageScrim(stage, open) {
      var scrim = stage.querySelector('[data-scrim]');
      if (!scrim) return;
      scrim.classList.toggle('is-open', open);
      if (open) {
        scrim.style.setProperty('--scrim-top', PANEL_BOTTOM + 'px');
      } else {
        scrim.style.removeProperty('--scrim-top');
      }
      var toggle = stage.querySelector('[data-scrim-demo-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-scrim-demo-toggle]');
      if (toggle) {
        var stage = toggle.closest('[data-scrim-demo-stage]');
        setStageScrim(stage, !stage.querySelector('[data-scrim]').classList.contains('is-open'));
        return;
      }
      if (!event.target.closest || !event.target.closest('[data-scrim]')) return;
      var scrim = event.target.closest('[data-scrim]');
      var demoStage = scrim.closest('[data-scrim-demo-stage]');
      if (demoStage && scrim.id !== 'scrim-demo-visible') {
        setStageScrim(demoStage, false);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-demo-seo-copy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('seo-copy')) {
    /* The section defines the real element; the demo only needs the
       behaviour on its demo instances. The section's definition wins if
       it loaded first - this fallback only upgrades demo-only markup. */
    class SeoCopyDemo extends HTMLElement {
      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.__body = this.querySelector('.seo-copy__body');
        this.__toggle = this.querySelector('[data-seo-copy-toggle]');
        if (!this.__body || !this.__toggle) return;
        const lines = parseInt(this.dataset.collapseLines, 10) || 6;
        this.style.setProperty('--seo-copy-lines', String(lines));
        this.__body.classList.add('seo-copy__body--clamped');
        this.__collapsed = true;
        this.__toggle.addEventListener('click', () => {
          this.__collapsed = !this.__collapsed;
          this.__body.classList.toggle('seo-copy__body--clamped', this.__collapsed);
          this.__toggle.setAttribute('aria-expanded', this.__collapsed ? 'false' : 'true');
          this.setAttribute('aria-expanded', this.__collapsed ? 'false' : 'true');
          this.__toggle.querySelector('.seo-copy__toggle-label').textContent = this.__collapsed
            ? this.__toggle.dataset.labelMore
            : this.__toggle.dataset.labelLess;
        });
      }
    }
    if (!customElements.get('seo-copy')) {
      customElements.define('seo-copy', SeoCopyDemo);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-demo-write-a-review"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__dsWarDemo) return;
    window.__dsWarDemo = true;

    var TRANSITION_MS = 300;

    function setStage(demo, open) {
      var drawer = demo.querySelector('[data-write-a-review]');
      if (!drawer || drawer.getAttribute('data-war-demo') !== 'live') return;
      if (open) {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
      } else {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      }
      var toggle = demo.querySelector('[data-war-demo-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    document.addEventListener('click', function (event) {
      /* pin the drawn-board specimens open on load (their JS loaded with
         closed state; the stage neutralises the geometry so is-open only
         toggles visibility) */
      var pinned = document.querySelectorAll('.ds-war-demo-pinned');
      for (var i = 0; i < pinned.length; i++) {
        if (!pinned[i].classList.contains('is-open')) {
          pinned[i].classList.add('is-open');
          pinned[i].setAttribute('aria-hidden', 'false');
        }
      }
      var toggle = event.target.closest('[data-war-demo-toggle]');
      if (toggle) {
        var demo = toggle.closest('[data-war-demo-interactive]');
        var drawer = demo.querySelector('[data-write-a-review]');
        setStage(demo, !drawer.classList.contains('is-open'));
        return;
      }
      if (!event.target.closest || !event.target.closest('.ds-war-demo')) return;
      /* inside the interactive specimen: close button, scrim, Esc already
         handled by the element's own JS; the demo just mirrors the toggle */
      var liveDrawer = event.target.closest('[data-write-a-review][data-war-demo="live"]');
      if (liveDrawer) {
        var demoBox = liveDrawer.closest('[data-war-demo-interactive]');
        window.setTimeout(function () {
          setStage(demoBox, liveDrawer.classList.contains('is-open'));
        }, TRANSITION_MS + 30);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var demo = document.querySelector('[data-war-demo-interactive]');
      if (!demo) return;
      var drawer = demo.querySelector('[data-write-a-review]');
      if (drawer && drawer.classList.contains('is-open')) {
        window.setTimeout(function () { setStage(demo, false); }, TRANSITION_MS + 30);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-group"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('filter-group')) {
    customElements.define(
      'filter-group',
      class FilterGroup extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.details = this.querySelector('[data-filter-group-details]');
          this.list = this.querySelector('[data-filter-group-list]');
          this.search = this.querySelector('[data-filter-group-search]');
          this.more = this.querySelector('[data-filter-group-more]');
          this.price = this.querySelector('[data-filter-group-price]');
          this.__onToggle = () => this.__persist();
          this.__onSearch = () => this.__filterRows();
          this.__onMore = () => this.__revealAll();
          this.__onBand = (event) => this.__syncBands(event);
          if (this.details) this.details.addEventListener('toggle', this.__onToggle);
          if (this.search) this.search.addEventListener('input', this.__onSearch);
          if (this.more) this.more.addEventListener('click', this.__onMore);
          if (this.price) this.price.addEventListener('change', this.__onBand);
          this.__restore();
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          if (this.details) this.details.removeEventListener('toggle', this.__onToggle);
          if (this.search) this.search.removeEventListener('input', this.__onSearch);
          if (this.more) this.more.removeEventListener('click', this.__onMore);
          if (this.price) this.price.removeEventListener('change', this.__onBand);
        }

        /* Bands are checkbox rows for visual parity with the other facets, but
           Shopify's price filter is one gte/lte pair, so they behave
           exclusively: ticking one unticks the rest. This writes the hidden
           pair and then lets the event carry on bubbling to the host form,
           whose own handler serialises and fetches - this listener sits on the
           group, inside the form, so it always runs first. */
        __syncBands(event) {
          const box = event.target.closest('[data-filter-price-band]');
          if (!box) return;

          const gte = this.querySelector('[data-filter-price-bound="gte"]');
          const lte = this.querySelector('[data-filter-price-bound="lte"]');
          if (!gte || !lte) return;

          if (box.checked) {
            this.querySelectorAll('[data-filter-price-band]').forEach((other) => {
              if (other !== box) other.checked = false;
            });
            gte.value = box.dataset.gte || '';
            lte.value = box.dataset.lte || '';
          } else {
            gte.value = '';
            lte.value = '';
          }
        }

        __storageKey() {
          return 'filter-group:' + (this.dataset.groupId || 'group');
        }

        __persist() {
          try {
            sessionStorage.setItem(this.__storageKey(), this.details.open ? 'open' : 'closed');
          } catch (error) {
            /* storage unavailable - state simply does not persist */
          }
        }

        __restore() {
          if (!this.details) return;
          let state = null;
          try {
            state = sessionStorage.getItem(this.__storageKey());
          } catch (error) {
            state = null;
          }
          if (state === 'open' && !this.details.open) this.details.open = true;
          if (state === 'closed' && this.details.open) this.details.open = false;

          /* Picking a row re-renders the form, which rebuilt the group with
             its list capped again - on Brand you could not pick a second
             brand without pressing Show all each time (Synergy UAT, Steph
             24 Sep). The reveal is remembered per page, so it survives the
             re-render but a new collection starts capped. */
          let more = null;
          try {
            more = sessionStorage.getItem(this.__moreKey());
          } catch (error) {
            more = null;
          }
          if (more === 'all' && this.more) this.__revealAll();
        }

        __moreKey() {
          return this.__storageKey() + ':more:' + window.location.pathname;
        }

        __revealAll() {
          if (!this.list) return;
          this.list.querySelectorAll('.filter-group__row--extra').forEach((row) => {
            row.classList.remove('filter-group__row--extra');
            row.classList.add('filter-group__row--revealed');
          });
          if (this.more) {
            this.more.setAttribute('aria-expanded', 'true');
            this.more.remove();
            this.more = null;
          }
          this.__expanded = true;
          try {
            sessionStorage.setItem(this.__moreKey(), 'all');
          } catch (error) {
            /* storage unavailable - the reveal simply does not persist */
          }
        }

        __filterRows() {
          if (!this.search || !this.list) return;
          const query = this.search.value.trim().toLowerCase();
          if (query !== '' && !this.__expanded) this.__revealAll();
          this.list.querySelectorAll('.filter-row').forEach((row) => {
            const label = row.querySelector('.filter-row__label');
            const text = label ? label.textContent.trim().toLowerCase() : '';
            row.classList.toggle('filter-group__row--filtered', query !== '' && text.indexOf(query) === -1);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filters-sidebar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('filters-sidebar')) {
    customElements.define(
      'filters-sidebar',
      class FiltersSidebar extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.form = this.querySelector('[data-filter-form]');
          this.__onChange = (event) => this.__handleChange(event);
          this.__onSubmit = (event) => event.preventDefault();
          this.__onPopState = () => this.__fetchAndSwap(window.location.href);
          this.__onFacetsChanged = (event) => this.__handleExternalChange(event);
          if (this.form) {
            this.form.addEventListener('change', this.__onChange);
            this.form.addEventListener('submit', this.__onSubmit);
          }
          window.addEventListener('popstate', this.__onPopState);
          document.addEventListener('facets:changed', this.__onFacetsChanged);
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          if (this.form) {
            this.form.removeEventListener('change', this.__onChange);
            this.form.removeEventListener('submit', this.__onSubmit);
          }
          window.removeEventListener('popstate', this.__onPopState);
          document.removeEventListener('facets:changed', this.__onFacetsChanged);
        }

        __handleChange(event) {
          const target = event.target;
          if (!target || !target.matches) return;
          /* Checkboxes are the option rows; number inputs are the price range
             pair, which commits on change (blur / Enter / arrow keys) rather
             than per keystroke - the swap below replaces the form's markup.
             The in-facet search field is type=search and carries no name, so
             it never reaches here and never lands in the query. */
          if (!target.matches('input[type="checkbox"], input[type="number"]')) return;
          const url = this.__buildUrl().toString();
          if (url === this.__appliedUrl) return;
          history.pushState({}, '', url);
          this.__fetchAndSwap(url);
          document.dispatchEvent(
            new CustomEvent('facets:changed', { detail: { url: url, source: this } })
          );
        }

        __handleExternalChange(event) {
          if (!event.detail || !event.detail.url) return;
          if (event.detail.source === this) return;
          this.__fetchAndSwap(event.detail.url);
        }

        __buildUrl() {
          const url = new URL(window.location.href);
          const kept = new URLSearchParams();
          const current = new URLSearchParams(window.location.search);
          current.forEach((value, key) => {
            if (key === 'sort_by' || key === 'q') kept.append(key, value);
          });
          if (this.form) {
            /* Serialise the whole form, not just the checkboxes - the price
               range pair is a named number input and was being dropped from
               the query (QA PL1). FormData already skips unchecked boxes,
               disabled fields and unnamed inputs (the in-facet search); empty
               price fields are skipped here so a half-set range still works. */
            new FormData(this.form).forEach((value, key) => {
              if (typeof value !== 'string') return;
              const trimmed = value.trim();
              if (trimmed === '') return;
              kept.append(key, trimmed);
            });
          }
          url.search = kept.toString();
          return url;
        }

        __fetchAndSwap(url) {
          const sectionId = this.form ? this.form.dataset.sectionId : null;
          if (!sectionId) return;
          this.__appliedUrl = url;
          if (this.__abort) this.__abort.abort();
          this.__abort = new AbortController();
          const fetchUrl = new URL(url, window.location.origin);
          fetchUrl.searchParams.set('section_id', sectionId);
          if (this.form) this.form.setAttribute('aria-busy', 'true');
          fetch(fetchUrl.toString(), { signal: this.__abort.signal })
            .then((response) => {
              if (!response.ok) throw new Error('facet fetch failed');
              return response.text();
            })
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.querySelector('[data-filters-sidebar]');
              const freshForm = fresh ? fresh.querySelector('[data-filter-form]') : null;
              if (freshForm && this.form) {
                const activeId =
                  document.activeElement && this.form.contains(document.activeElement)
                    ? document.activeElement.id
                    : null;
                this.form.innerHTML = freshForm.innerHTML;
                if (activeId) {
                  const refocus = this.form.querySelector('#' + window.CSS.escape(activeId));
                  if (refocus) refocus.focus();
                }
              }
            })
            .catch((error) => {
              if (error && error.name !== 'AbortError') {
                window.location.href = url;
              }
            })
            .finally(() => {
              if (this.form) this.form.removeAttribute('aria-busy');
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-input"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__formInputCounter) return;
    window.__formInputCounter = true;

    document.addEventListener('input', function (event) {
      var target = event.target.closest('textarea[data-field-counter-target]');
      if (!target) return;

      var counter = document.getElementById(
        target.getAttribute('data-field-counter-target')
      );
      if (!counter) return;

      var max = target.getAttribute('maxlength');
      var text = counter.textContent.trim();
      var match = text.match(/^(\d+)(.*)$/);
      if (!match) return;

      counter.textContent = target.value.length + match[2];
      if (max) counter.setAttribute('data-max', max);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-form"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (customElements.get('gift-card-form')) return;

    var GC_DAY_MS = 24 * 60 * 60 * 1000;
    var GC_MAX_DAYS = 90;
    var GC_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    class GiftCardForm extends HTMLElement {
      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;

        this.__strings = window.__giftCardFormStrings || {};

        this.__offsetInput = this.querySelector('[data-gift-card-offset]');
        this.__denominations = Array.prototype.slice.call(
          this.querySelectorAll('[data-gift-card-denomination]')
        );
        this.__otherToggle = this.querySelector('[data-gift-card-other-toggle]');
        this.__otherWrap = this.querySelector('[data-gift-card-other]');
        this.__otherInput = this.querySelector('input[name="gift_card_other_amount"]') || this.querySelector('[data-gift-card-other-input] input');
        this.__recipientToggle = this.querySelector('[data-gift-card-recipient-toggle]');
        this.__emailInput = this.querySelector('input[name="properties[Recipient email]"]') || this.querySelector('[data-gift-card-recipient-email] input');
        this.__sendOnSelect = this.querySelector('select[name="gift_card_send_on_ui"]');
        this.__sendOnInput = this.querySelector('[data-gift-card-send-on]');

        if (this.__offsetInput) {
          this.__offsetInput.value = String(new Date().getTimezoneOffset());
        }

        this.__denominations.forEach(function (radio) {
          radio.addEventListener('change', () => {
            if (radio.checked) this.__onDenominationChange(radio);
          });
        }, this);

        if (this.__otherToggle) {
          this.__otherToggle.addEventListener('click', this.__toggleOther.bind(this));
        }

        if (this.__otherInput) {
          this.__otherInput.addEventListener('input', this.__validateOther.bind(this));
        }

        if (this.__emailInput) {
          this.__emailInput.addEventListener('input', this.__clearEmailError.bind(this));
          this.__emailInput.addEventListener('change', this.__validateEmail.bind(this));
        }

        this.__populateSendOn();
        if (this.__sendOnSelect) {
          this.__sendOnSelect.addEventListener('change', this.__onSendOnChange.bind(this));
        }
      }

      disconnectedCallback() {
        this.__bound = false;
      }

      __formId() {
        var first = this.querySelector('[form]');
        return first ? first.getAttribute('form') : null;
      }

      __form() {
        var formId = this.__formId();
        return formId ? document.getElementById(formId) : null;
      }

      __onDenominationChange(radio) {
        this.__clearOther();
        this.__setVariant(radio);
      }

      __setVariant(radio) {
        var form = this.__form();
        if (!form) return;
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = radio.getAttribute('data-variant-id');
        document.dispatchEvent(
          new CustomEvent('product:variant-change', {
            detail: {
              variant_id: radio.getAttribute('data-variant-id'),
              price: radio.getAttribute('data-variant-price'),
              source: 'gift-card-form'
            }
          })
        );
        /* Bubbles from the element (not document-dispatched like the
           carried product:variant-change) so the host section can scope
           its listener to its own root via event.target.closest. */
        this.dispatchEvent(
          new CustomEvent('gift-card-form:variant-change', {
            bubbles: true,
            detail: {
              variant_id: radio.getAttribute('data-variant-id'),
              price: radio.getAttribute('data-variant-price'),
              source: 'gift-card-form'
            }
          })
        );
      }

      __toggleOther() {
        if (!this.__otherWrap) return;
        if (this.__otherWrap.hidden) {
          this.__otherWrap.hidden = false;
          this.__otherToggle.setAttribute('aria-expanded', 'true');
          this.__otherToggle.classList.add('pill--active');
          this.__denominations.forEach(function (radio) {
            radio.checked = false;
          });
          if (this.__otherInput) this.__otherInput.focus();
        } else {
          this.__clearOther();
        }
      }

      __clearOther() {
        if (!this.__otherWrap) return;
        this.__otherWrap.hidden = true;
        this.__otherToggle.setAttribute('aria-expanded', 'false');
        this.__otherToggle.classList.remove('pill--active');
        if (this.__otherInput) {
          this.__otherInput.value = '';
          this.__otherInput.removeAttribute('aria-invalid');
        }
      }

      __validateOther() {
        if (!this.__otherInput) return true;
        var value = parseInt(this.__otherInput.value, 10);
        var min = parseInt(this.__otherInput.getAttribute('min'), 10) || 25;
        var max = parseInt(this.__otherInput.getAttribute('max'), 10) || 500;
        if (!this.__otherInput.value || (value >= min && value <= max)) {
          this.__otherInput.removeAttribute('aria-invalid');
          return true;
        }
        this.__otherInput.setAttribute('aria-invalid', 'true');
        return false;
      }

      __validateEmail() {
        if (!this.__emailInput) return true;
        var value = this.__emailInput.value.trim();
        if (!value || GC_EMAIL_RE.test(value)) {
          this.__clearEmailError();
          return true;
        }
        this.__emailInput.setAttribute('aria-invalid', 'true');
        return false;
      }

      __clearEmailError() {
        if (this.__emailInput) this.__emailInput.removeAttribute('aria-invalid');
      }

      __populateSendOn() {
        var select = this.__sendOnSelect;
        if (!select || select.options.length > 1) return;
        var start = new Date();
        start.setHours(0, 0, 0, 0);
        for (var day = 1; day <= GC_MAX_DAYS; day++) {
          var date = new Date(start.getTime() + day * GC_DAY_MS);
          var option = document.createElement('option');
          option.value = date.toISOString().slice(0, 10);
          option.textContent = date.toLocaleDateString(undefined, {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          });
          select.appendChild(option);
        }
      }

      __onSendOnChange() {
        var value = this.__sendOnSelect.value;
        if (this.__recipientToggle) this.__recipientToggle.checked = true;
        if (this.__sendOnInput) this.__sendOnInput.value = value === 'immediate' ? '' : value;
      }
    }

    customElements.define('gift-card-form', GiftCardForm);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["instant-search"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('instant-search')) return;

    var DEBOUNCE_MS = 150;
    var RESULTS_SECTION_ID = 'instant-search-results';

    class InstantSearch extends HTMLElement {
      constructor() {
        super();
        this.bound = false;
        this.debounceId = null;
        this.abortController = null;
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onKeyDown = this.handleKeyDown.bind(this);
        this.onCloseRequest = this.handleCloseRequest.bind(this);
        this.onDrawerOpen = this.handleOverlayOpen.bind(this);
      }

      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.isMobile = this.getAttribute('data-context') === 'mobile';
        this.form = this.querySelector('form');
        /* Neither shell owns a field: mobile reads the header pill
           (data-header-search-trigger), desktop the header bar. */
        this.input = document.querySelector(
          this.isMobile ? '[data-header-search-trigger]' : '[data-header-search-input]'
        );
        this.results = this.querySelector('[data-instant-search-results]');
        this.productsRegion = this.querySelector('[data-instant-search-products]');
        this.defaultRegion = this.querySelector('[data-instant-search-default]');
        this.noResults = this.querySelector('[data-instant-search-no-results]');
        this.viewAllRow = this.querySelector('[data-instant-search-view-all-row]');
        this.viewAll = this.querySelector('[data-instant-search-view-all]');
        this.viewAllLabel = this.querySelector('[data-instant-search-view-all-label]');
        this.queryField = this.querySelector('[data-instant-search-query]');
        this.searchUrl = this.form ? this.form.getAttribute('action') : '/search';

        if (!this.results) return;

        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('search:close', this.onCloseRequest);
        document.addEventListener('drawer:open', this.onDrawerOpen);
        document.addEventListener('cart:open', this.onDrawerOpen);

        if (this.input) {
          this.input.addEventListener('focus', this.openBound = this.open.bind(this));
          this.input.addEventListener('input', this.onInputBound = this.debounceQuery.bind(this));
          /* the header field lives outside this form: mirror its value into
             the hidden q input and submit on Enter */
          this.input.addEventListener('keydown', this.onInputKeydown = function (event) {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            this.submitQuery();
          }.bind(this));
        }
      }

      disconnectedCallback() {
        if (!this.bound) return;
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('search:close', this.onCloseRequest);
        document.removeEventListener('drawer:open', this.onDrawerOpen);
        document.removeEventListener('cart:open', this.onDrawerOpen);
        if (this.input) {
          this.input.removeEventListener('input', this.onInputBound);
          this.input.removeEventListener('focus', this.openBound);
          if (this.onInputKeydown) this.input.removeEventListener('keydown', this.onInputKeydown);
        }
        this.bound = false;
      }

      /* ---- state machine ---- */

      open() {
        if (this.suppressOpen) return;
        if (this.getAttribute('data-state') !== 'closed') return;
        var value = this.input && this.input.value ? this.input.value.trim() : '';
        this.setState('suggestions');
        document.body.setAttribute('data-search-open', '');
        this.setScrim(true);
        document.dispatchEvent(new CustomEvent('search:open', { bubbles: true }));
        /* reopening with text still in the field goes straight back to
           results; reopening EMPTY resets the regions (stale results list,
           hidden default rail) that a previous query left behind. */
        if (value) {
          this.setState('loading');
          this.fetchResults(value);
        } else {
          this.showSuggestionsOnly();
        }
      }

      close() {
        if (this.getAttribute('data-state') === 'closed') return;
        this.setState('closed');
        document.body.removeAttribute('data-search-open');
        this.setScrim(false);
        document.dispatchEvent(new CustomEvent('search:close', { bubbles: true }));
        if (this.input && document.activeElement && this.contains(document.activeElement)) {
          var focusTarget = document.querySelector(this.isMobile ? '[data-header-search-trigger]' : '[data-header-search-input]');
          if (focusTarget) {
            /* returning focus to the header field must not re-open the panel
               through the field's focus listener */
            this.suppressOpen = true;
            focusTarget.focus();
            this.suppressOpen = false;
          }
        }
      }

      submitQuery() {
        var value = this.input ? this.input.value.trim() : '';
        if (!value) return;
        if (this.queryField) this.queryField.value = value;
        this.form.submit();
      }

      /* ---- predictive query ---- */

      debounceQuery() {
        var self = this;
        clearTimeout(this.debounceId);
        this.debounceId = setTimeout(function () {
          /* a closed panel must stay closed: a native Escape on a
             type="search" input clears the value and fires `input` right
             after close -- without this guard that reopens the panel */
          if (self.getAttribute('data-state') === 'closed') return;
          var value = self.input ? self.input.value.trim() : '';
          if (!value) {
            self.showSuggestionsOnly();
            return;
          }
          /* loading is visually quiet: theme defaults per #19, no spinner */
          self.setState('loading');
          document.dispatchEvent(new CustomEvent('search:query', {
            bubbles: true,
            detail: { query: value }
          }));
          self.fetchResults(value);
        }, DEBOUNCE_MS);
      }

      /* One request per settled query: the Section Rendering API on the search
         route returns product-card renders AND the live results_count that
         suggest.json cannot supply. */
      fetchResults(query) {
        var self = this;
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        /* Trailing wildcard: partial terms match as prefixes ("sham" ->
           shampoo) - without it the search route needs whole words and the
           overlay dead-ends while the shopper is mid-word (sweep P2).
           options[prefix]=last is inert on this route; the * syntax works.
           Terms already ending in * are left alone. */
        var prefixQuery = /\*\s*$/.test(query) ? query : query + '*';
        var fetchUrl = this.searchUrl +
          '?q=' + encodeURIComponent(prefixQuery) +
          '&type=product&section_id=' + RESULTS_SECTION_ID;

        fetch(fetchUrl, { signal: this.abortController.signal })
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var payload = doc.querySelector('[data-instant-search-count]');
            if (!payload) {
              self.showSuggestionsOnly();
              return;
            }
            var count = parseInt(payload.getAttribute('data-instant-search-count'), 10) || 0;
            self.renderResults(count, payload, query);
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            self.showSuggestionsOnly();
          });
      }

      /* ---- rendering ---- */

      showSuggestionsOnly() {
        if (this.abortController) this.abortController.abort();
        if (this.productsRegion) this.productsRegion.hidden = true;
        if (this.defaultRegion) this.defaultRegion.hidden = false;
        if (this.noResults) this.noResults.hidden = true;
        if (this.viewAllRow) this.viewAllRow.hidden = true;
        this.results.textContent = '';
        this.setState('suggestions');
      }

      renderResults(count, payload, query) {
        var items = payload.querySelector('[data-instant-search-items]');
        var label = payload.querySelector('[data-instant-search-view-all-label]');

        this.results.textContent = '';
        if (this.productsRegion) this.productsRegion.hidden = false;
        if (this.defaultRegion) this.defaultRegion.hidden = true;

        if (count > 0 && items) {
          while (items.firstChild) this.results.appendChild(items.firstChild);
          if (this.noResults) this.noResults.hidden = true;
          if (label && this.viewAllLabel) this.viewAllLabel.textContent = label.textContent.trim();
          /* View-all carries the SAME starred query the overlay counted
             with, so the landing page's result set matches the promise. */
          if (this.viewAll) {
            var vaQuery = /\*\s*$/.test(query) ? query : query + '*';
            this.viewAll.setAttribute('href', this.searchUrl + '?q=' + encodeURIComponent(vaQuery));
          }
          if (this.viewAllRow) this.viewAllRow.hidden = false;
          this.setState('results');
        } else {
          /* No-results keeps both curated groups on: a dead end with nothing
             to tap is worse than one with somewhere to go. View-all stays
             hidden — it would land the shopper on an equally empty page. */
          if (this.noResults) this.noResults.hidden = false;
          if (this.viewAllRow) this.viewAllRow.hidden = true;
          this.setState('no-results');
        }
      }

      /* ---- plumbing ---- */

      setState(state) {
        this.setAttribute('data-state', state);
        /* The panel's height changes with its contents and the scrim starts
           at the panel's bottom edge, so it has to follow. */
        if (state !== 'closed') this.setScrim(true);
      }

      setScrim(open) {
        var scrim = document.querySelector('[data-scrim]');
        if (!scrim) return;
        if (!open) {
          scrim.classList.remove('is-open');
          scrim.style.removeProperty('--scrim-top');
          return;
        }
        var self = this;
        /* Measure the panel's own box, not its client rect: the mobile shell
           reveals by animating grid-template-rows 0fr -> 1fr, so a rect read
           on the opening frame catches the panel mid-animation. The shell's
           top does not animate, and offsetHeight is the settled height. */
        var place = function () {
          var panel = self.querySelector('[data-instant-search-panel]');
          if (!panel) return;
          var top = self.getBoundingClientRect().top;
          scrim.style.setProperty('--scrim-top', Math.round(top + panel.offsetHeight) + 'px');
        };
        place();
        /* rAF is paused in a backgrounded tab, so the synchronous pass above
           has to stand on its own; this only refines it. */
        requestAnimationFrame(place);
        scrim.classList.add('is-open');
      }

      handleDocumentClick(event) {
        if (!event.target || !event.target.closest) return;
        if (event.target.closest('[data-scrim]')) { this.close(); return; }
        if (this.getAttribute('data-state') === 'closed') return;
        if (event.target.closest('[data-header-search-trigger]')) return;
        /* The custom clear button (flags 56) is search chrome, not an
           outside click - closing here would swallow the clear-and-reset
           flow before the input event lands. */
        if (event.target.closest('[data-header-search-clear]')) return;
        if (!event.target.closest('[data-header-search-input]') && !this.contains(event.target)) {
          this.close();
        }
      }

      handleKeyDown(event) {
        if (event.key !== 'Escape') return;
        if (this.getAttribute('data-state') === 'closed') return;
        this.close();
      }

      handleCloseRequest() {
        this.close();
      }

      handleOverlayOpen() {
        this.close();
      }
    }

    customElements.define('instant-search', InstantSearch);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('mega-menu')) return;

    var OPEN_DELAY = 100;
    var CLOSE_DELAY = 60;
    var TRANSITION_MS = 220;

    function panelBottom(el) {
      /* The settled bottom: getBoundingClientRect reads the ENTRANCE
         transform (translateY(-8px)) while the 200ms entrance is still
         running, so the scrim's --scrim-top landed 8px above the settled
         panel edge (measured 6 Sep: scrim 824 vs panel 831). Compensate by
         subtracting the current translateY from the rect. */
      var r = el.getBoundingClientRect();
      var ty = 0;
      var m = getComputedStyle(el).transform;
      if (m && m !== 'none') {
        var parts = m.match(/matrix\(([^)]+)\)/);
        if (parts) {
          ty = parseFloat(parts[1].split(',')[5]) || 0;
        }
      }
      return r.bottom - ty;
    }

    function MegaMenuElement() {
      return Reflect.construct(HTMLElement, [], MegaMenuElement);
    }
    MegaMenuElement.prototype = Object.create(HTMLElement.prototype);
    MegaMenuElement.prototype.constructor = MegaMenuElement;
    MegaMenuElement.prototype.connectedCallback = function () {
      var root = this;
      if (root._bound) return;
      root._bound = true;
      root._intentTimer = null;
      root._closeTimer = null;
      root._hideTimer = null;

      root._onPointerEnter = function () {
        root._clearClose();
        root._clearHide();
        root._intentTimer = window.setTimeout(function () {
          root._intentTimer = null;
          root.open();
        }, OPEN_DELAY);
      };
      root._onPointerLeave = function () {
        root._clearIntent();
        root._closeTimer = window.setTimeout(function () {
          root._closeTimer = null;
          root.close();
        }, CLOSE_DELAY);
      };
      root._onFocusIn = function () {
        /* Keyboard focus on the trigger opens the panel - except the focus
           return performed by close() itself (Esc), which must not re-open. */
        if (root._restoringFocus) {
          root._restoringFocus = false;
          return;
        }
        root._clearClose();
        root.open();
      };
      root._onFocusOut = function (event) {
        var to = event.relatedTarget;
        var inside = (to && (root.contains(to))) || (root._triggerEl && (to === root._triggerEl || root._triggerEl.contains(to)));
        if (!inside) {
          root._clearIntent();
          root.close();
        }
      };
      root._onKeydown = function (event) {
        if (event.key === 'Escape') {
          root.close(true);
        }
      };

      root.addEventListener('pointerenter', root._onPointerEnter);
      root.addEventListener('pointerleave', root._onPointerLeave);
      root.addEventListener('focusin', root._onFocusIn);
      root.addEventListener('focusout', root._onFocusOut);
      root.addEventListener('keydown', root._onKeydown);

      /* The trigger (header nav item) opens the panel on hover/focus-intent;
         the panel keeps it open while the pointer is over either surface. */
      root._triggerEl = root._trigger();
      if (root._triggerEl && !root._triggerEl.__megaMenuHooked) {
        root._triggerEl.__megaMenuHooked = true;
        root._triggerEl.addEventListener('pointerenter', root._onPointerEnter);
        root._triggerEl.addEventListener('pointerleave', root._onPointerLeave);
        root._triggerEl.addEventListener('focusin', root._onFocusIn);
        root._triggerEl.addEventListener('focusout', root._onFocusOut);
        root._triggerEl.addEventListener('keydown', root._onKeydown);
      }
    };
    MegaMenuElement.prototype.disconnectedCallback = function () {
      var root = this;
      if (!root._bound) return;
      root._bound = false;
      root._clearIntent();
      root._clearClose();
      root._clearHide();
      root.removeEventListener('pointerenter', root._onPointerEnter);
      root.removeEventListener('pointerleave', root._onPointerLeave);
      root.removeEventListener('focusin', root._onFocusIn);
      root.removeEventListener('focusout', root._onFocusOut);
      root.removeEventListener('keydown', root._onKeydown);
      if (root._triggerEl) {
        root._triggerEl.__megaMenuHooked = false;
        root._triggerEl.removeEventListener('pointerenter', root._onPointerEnter);
        root._triggerEl.removeEventListener('pointerleave', root._onPointerLeave);
        root._triggerEl.removeEventListener('focusin', root._onFocusIn);
        root._triggerEl.removeEventListener('focusout', root._onFocusOut);
        root._triggerEl.removeEventListener('keydown', root._onKeydown);
      }
    };
    MegaMenuElement.prototype._clearIntent = function () {
      if (this._intentTimer) {
        window.clearTimeout(this._intentTimer);
        this._intentTimer = null;
      }
    };
    MegaMenuElement.prototype._clearClose = function () {
      if (this._closeTimer) {
        window.clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
    };
    MegaMenuElement.prototype._clearHide = function () {
      if (this._hideTimer) {
        window.clearTimeout(this._hideTimer);
        this._hideTimer = null;
      }
    };
    MegaMenuElement.prototype._trigger = function () {
      var id = this.getAttribute('data-mega-menu-id');
      if (!id) return null;
      return document.querySelector('[data-mega-trigger="' + id + '"]');
    };
    MegaMenuElement.prototype.open = function () {
      var root = this;
      root._clearIntent();
      if (root.getAttribute('data-open') === 'true') return;
      root.hidden = false;
      requestAnimationFrame(function () {
        root.setAttribute('data-open', 'true');
      });
      var trigger = root._trigger();
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
        trigger.classList.add('is-active');
      }
      document.documentElement.setAttribute('data-mega-open', root.getAttribute('data-mega-menu-id'));
      root._showScrim();
      document.dispatchEvent(
        new CustomEvent('megamenu:open', {
          detail: { id: root.getAttribute('data-mega-menu-id') }
        })
      );
    };
    MegaMenuElement.prototype.close = function (returnFocus) {
      var root = this;
      root._clearClose();
      if (root.getAttribute('data-open') !== 'true') {
        root.hidden = true;
        return;
      }
      root.setAttribute('data-open', 'false');
      var trigger = root._trigger();
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-active');
        if (returnFocus === true && typeof trigger.focus === 'function') {
          root._restoringFocus = true;
          trigger.focus();
        }
      }
      if (document.documentElement.getAttribute('data-mega-open') === root.getAttribute('data-mega-menu-id')) {
        document.documentElement.removeAttribute('data-mega-open');
      }
      root._hideScrim();
      root._clearHide();
      root._hideTimer = window.setTimeout(function () {
        root._hideTimer = null;
        if (root.getAttribute('data-open') !== 'true') root.hidden = true;
      }, TRANSITION_MS);
      document.dispatchEvent(
        new CustomEvent('megamenu:close', {
          detail: { id: root.getAttribute('data-mega-menu-id') }
        })
      );
    };
    MegaMenuElement.prototype._showScrim = function () {
      var scrim = document.querySelector('[data-scrim]');
      if (!scrim) return;
      scrim.style.setProperty('--scrim-top', Math.round(panelBottom(this)) + 'px');
      scrim.classList.add('is-open');
    };
    MegaMenuElement.prototype._hideScrim = function () {
      var panels = document.querySelectorAll('mega-menu[data-open="true"]');
      for (var i = 0; i < panels.length; i++) {
        if (!panels[i].closest('.ds-mm-demo-stage')) return;
      }
      var scrim = document.querySelector('[data-scrim]');
      if (!scrim) return;
      scrim.classList.remove('is-open');
      scrim.style.removeProperty('--scrim-top');
    };
    customElements.define('mega-menu', MegaMenuElement);
  })();

  (function () {
    if (window.__megaMenuDocHooks) return;
    window.__megaMenuDocHooks = true;
    function activePanel() {
      var panels = document.querySelectorAll('mega-menu[data-open="true"]');
      for (var i = 0; i < panels.length; i++) {
        if (!panels[i].closest('.ds-mm-demo-stage')) return panels[i];
      }
      return null;
    }
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var active = activePanel();
      if (active && typeof active.close === 'function') active.close(true);
    });
    document.addEventListener('scrim:click', function () {
      var active = activePanel();
      if (active && typeof active.close === 'function') active.close();
    });
    document.addEventListener('header:search:open', function () {
      var active = activePanel();
      if (active && typeof active.close === 'function') active.close();
    });
    document.addEventListener('header:cart:open', function () {
      var active = activePanel();
      if (active && typeof active.close === 'function') active.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-filter-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('filter-drawer')) return;

    var TRANSITION_MS = 200;
    var MOBILE_QUERY = '(max-width: 749.98px)';

    customElements.define(
      'filter-drawer',
      class FilterDrawer extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.panel = this.querySelector('.filter-drawer__panel');
          this.form = this.querySelector('[data-filter-form]');
          this.footer = this.querySelector('[data-filter-drawer-footer]');
          this.applied = this.querySelector('[data-filter-drawer-applied]');
          this.__invoker = null;
          this.__mobileQuery = window.matchMedia(MOBILE_QUERY);
          this.__onClick = this.__handleClick.bind(this);
          this.__onKeydown = this.__handleKeydown.bind(this);
          this.__onScrim = this.close.bind(this, false);
          this.__onOpenEvent = function (event) {
            var invoker = event && event.detail && event.detail.invoker;
            this.open(invoker || null);
          }.bind(this);
          this.__onChange = this.__handleChange.bind(this);
          this.__onSubmit = function (event) { event.preventDefault(); };
          this.__onPopState = function () { this.__fetchAndSwap(window.location.href); }.bind(this);
          this.__onFacetsChanged = this.__handleExternalChange.bind(this);
          this.__onViewportChange = this.__handleViewportChange.bind(this);
          this.__onFocusIn = this.__trapFocus.bind(this);
          if (this.form) {
            this.form.addEventListener('change', this.__onChange);
            this.form.addEventListener('submit', this.__onSubmit);
          }
          this.addEventListener('focusin', this.__onFocusIn);
          document.addEventListener('click', this.__onClick);
          document.addEventListener('keydown', this.__onKeydown);
          document.addEventListener('scrim:click', this.__onScrim);
          document.addEventListener('filter-drawer:open', this.__onOpenEvent);
          document.addEventListener('facets:changed', this.__onFacetsChanged);
          window.addEventListener('popstate', this.__onPopState);
          if (this.__mobileQuery.addEventListener) {
            this.__mobileQuery.addEventListener('change', this.__onViewportChange);
          } else {
            this.__mobileQuery.addListener(this.__onViewportChange);
          }
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          if (this.form) {
            this.form.removeEventListener('change', this.__onChange);
            this.form.removeEventListener('submit', this.__onSubmit);
          }
          this.removeEventListener('focusin', this.__onFocusIn);
          document.removeEventListener('click', this.__onClick);
          document.removeEventListener('keydown', this.__onKeydown);
          document.removeEventListener('scrim:click', this.__onScrim);
          document.removeEventListener('filter-drawer:open', this.__onOpenEvent);
          document.removeEventListener('facets:changed', this.__onFacetsChanged);
          window.removeEventListener('popstate', this.__onPopState);
          if (this.__mobileQuery.removeEventListener) {
            this.__mobileQuery.removeEventListener('change', this.__onViewportChange);
          } else {
            this.__mobileQuery.removeListener(this.__onViewportChange);
          }
        }

        get isOpen() {
          return this.classList.contains('is-open');
        }

        open(invoker) {
          if (this.isOpen) return;
          if (!this.__mobileQuery.matches) return;
          if (invoker) this.__invoker = invoker;
          this.classList.remove('is-closing');
          this.setAttribute('aria-hidden', 'false');
          this.__scrollLock(true);
          this.__showScrim();
          requestAnimationFrame(function () {
            this.classList.add('is-open');
            /* Focus must land after is-open flips visibility - focus()
               silently no-ops on a visibility:hidden panel (the cart-flyout
               gotcha, same defect class). */
            this.__focusPanel();
          }.bind(this));
        }

        close(returnFocus) {
          if (!this.isOpen) return;
          this.classList.remove('is-open');
          this.classList.add('is-closing');
          this.setAttribute('aria-hidden', 'true');
          this.__scrollLock(false);
          this.__hideScrim();
          window.setTimeout(function () {
            if (!this.isOpen) this.classList.remove('is-closing');
          }.bind(this), TRANSITION_MS);
          document.dispatchEvent(new CustomEvent('filter-drawer:close'));
          if (returnFocus !== false && this.__invoker && typeof this.__invoker.focus === 'function') {
            this.__invoker.focus();
            this.__invoker = null;
          }
        }

        __focusPanel() {
          if (this.panel && typeof this.panel.focus === 'function') this.panel.focus();
        }

        __trapFocus(event) {
          var focusables = this.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          if (!focusables.length) return;
          var list = Array.prototype.filter.call(focusables, function (el) { return el.offsetParent !== null; });
          if (!list.length) return;
          if (!this.contains(document.activeElement)) {
            list[0].focus();
          }
        }

        __handleKeydown(event) {
          if (!this.isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (event.key !== 'Tab') return;
          var focusables = this.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          var list = Array.prototype.filter.call(focusables, function (el) { return el.offsetParent !== null; });
          if (!list.length) return;
          var first = list[0];
          var last = list[list.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        __handleClick(event) {
          var target = event.target;
          if (!target || !target.closest) return;
          var opener = target.closest('[data-filter-drawer-open]');
          if (opener) {
            event.preventDefault();
            this.open(opener);
            return;
          }
          if (!this.isOpen) return;
          if (target.closest('[data-filter-drawer-close]')) {
            this.close();
            return;
          }
          /* "Apply filters" is the close-and-reveal affordance: selections
             already committed on change, so closing is all it does. */
          if (target.closest('[data-filter-drawer-show-results]')) {
            this.close();
            return;
          }
          if (target.closest('[data-filter-clear]')) {
            this.__clearAll();
            return;
          }
          var chip = target.closest('[data-filter-chip-remove]');
          if (chip) {
            /* The chip li carries data-filter-param / data-filter-value (the
               remove button inside it does not) - resolve up to it. */
            this.__removeChip(chip.closest('.filter-drawer__chip') || chip);
          }
        }

        __handleViewportChange(event) {
          if (!event.matches) this.close(false);
        }

        __clearAll() {
          if (!this.form) return;
          /* "Applied" is checked boxes AND a set price range - clearing used
             to count boxes only, so Clear all did nothing on a page filtered
             by price alone (QA PL1). */
          var applied = 0;
          this.form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
            input.checked = false;
            applied += 1;
          });
          this.form.querySelectorAll('[data-filter-price-input]').forEach(function (input) {
            if (input.value === '') return;
            input.value = '';
            applied += 1;
          });
          if (!applied) return;
          this.__applySelection();
        }

        __removeChip(chip) {
          var param = chip.getAttribute('data-filter-param');
          var value = chip.getAttribute('data-filter-value');
          var isPrice = chip.hasAttribute('data-filter-price');
          if (!this.form) return;
          var removed = 0;
          if (isPrice) {
            /* One chip stands for the whole gte/lte pair - removing it
               empties both bounds (QA PL1). */
            this.form.querySelectorAll('[data-filter-price-input]').forEach(function (input) {
              if (input.value === '') return;
              input.value = '';
              removed += 1;
            });
          } else if (param) {
            this.form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
              if (input.name === param && input.value === value) {
                input.checked = false;
                removed += 1;
              }
            });
          }
          if (!removed) return;
          this.__applySelection();
        }

        __handleChange(event) {
          var target = event.target;
          if (!target || !target.matches) return;
          /* Checkboxes are the option rows AND the price bands (whose hidden
             gte/lte pair carries the value); both commit on change. The
             in-facet search field is type=search and carries no name, so it
             neither commits nor lands in the query. */
          if (!target.matches('input[type="checkbox"], input[type="number"]')) return;
          this.__applySelection();
        }

        __applySelection() {
          var url = this.__buildUrl().toString();
          if (url === this.__appliedUrl) return;
          history.pushState({}, '', url);
          this.__fetchAndSwap(url);
          document.dispatchEvent(
            new CustomEvent('facets:changed', { detail: { url: url, source: this } })
          );
        }

        __handleExternalChange(event) {
          if (!event.detail || !event.detail.url) return;
          if (event.detail.source === this) return;
          this.__fetchAndSwap(event.detail.url);
        }

        __buildUrl() {
          var url = new URL(window.location.href);
          var kept = new URLSearchParams();
          var current = new URLSearchParams(window.location.search);
          current.forEach(function (value, key) {
            if (key === 'sort_by' || key === 'q') kept.append(key, value);
          });
          if (this.form) {
            /* Serialise the whole form, not just the checkboxes - the price
               range pair is a named input and was being dropped from the
               query (QA PL1). FormData already skips unchecked boxes,
               disabled fields and unnamed inputs (the in-facet search); empty
               price fields are skipped here so a half-set range still works. */
            new FormData(this.form).forEach(function (value, key) {
              if (typeof value !== 'string') return;
              var trimmed = value.trim();
              if (trimmed === '') return;
              kept.append(key, trimmed);
            });
          }
          url.search = kept.toString();
          return url;
        }

        __fetchAndSwap(url) {
          var sectionId = this.form ? this.form.dataset.sectionId : null;
          if (!sectionId) return;
          this.__appliedUrl = url;
          if (this.__abort) this.__abort.abort();
          this.__abort = new AbortController();
          var fetchUrl = new URL(url, window.location.origin);
          fetchUrl.searchParams.set('section_id', sectionId);
          if (this.form) this.form.setAttribute('aria-busy', 'true');
          fetch(fetchUrl.toString(), { signal: this.__abort.signal })
            .then(function (response) {
              if (!response.ok) throw new Error('facet fetch failed');
              return response.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-filter-drawer]');
              if (!fresh) return;
              var freshForm = fresh.querySelector('[data-filter-form]');
              if (freshForm && this.form) {
                this.form.innerHTML = freshForm.innerHTML;
              }
              /* The Applied Filters band morphs with the response so the
                 chips stay truthful while the drawer stays open. The band's
                 own hidden attribute is server-rendered from the fresh
                 facet state (hidden at zero applied values, schema 58). */
              var freshApplied = fresh.querySelector('[data-filter-drawer-applied]');
              if (freshApplied && this.applied) {
                this.applied.hidden = freshApplied.hidden;
                var freshList = freshApplied.querySelector('[data-filter-drawer-applied-list]');
                var list = this.applied.querySelector('[data-filter-drawer-applied-list]');
                if (freshList && list) list.innerHTML = freshList.innerHTML;
                /* The band's "Clear all" text action is server-rendered only
                   when the response has applied values - morph it in and out
                   with the chips so the band matches the SRA state exactly. */
                var freshClear = freshApplied.querySelector('[data-filter-clear]');
                var clear = this.applied.querySelector('[data-filter-clear]');
                if (freshClear && !clear) this.applied.insertAdjacentElement('beforeend', document.importNode(freshClear, true));
                if (!freshClear && clear) clear.remove();
              }
            }.bind(this))
            .catch(function (error) {
              if (error && error.name !== 'AbortError') {
                window.location.href = url;
              }
            })
            .finally(function () {
              if (this.form) this.form.removeAttribute('aria-busy');
            }.bind(this));
        }

        __scrollLock(locked) {
          document.documentElement.style.overflow = locked ? 'hidden' : '';
          document.body.style.overflow = locked ? 'hidden' : '';
        }

        __showScrim() {
          var scrim = document.querySelector('[data-scrim]');
          if (!scrim) return;
          scrim.style.setProperty('--scrim-top', '0px');
          scrim.classList.add('is-open');
        }

        __hideScrim() {
          var scrim = document.querySelector('[data-scrim]');
          if (!scrim) return;
          scrim.classList.remove('is-open');
          scrim.style.removeProperty('--scrim-top');
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nav-drawer-level2"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('nav-drawer-level2')) return;

    customElements.define(
      'nav-drawer-level2',
      class NavDrawerLevel2 extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.panel = this.querySelector('.nav-drawer-level2__panel');
          this.__onLevel = this.__syncLevel.bind(this);
          this.__onClick = this.__handleClick.bind(this);
          this.addEventListener('click', this.__onClick);
          document.addEventListener('drawer:level', this.__onLevel);
          this.__onClose = this.close.bind(this);
          // The level-1 drawer's close machinery (x / Esc / scrim) owns the
          // whole drawer - a close while a drill panel is pushed must reset
          // every level, or it renders over the next drawer-open.
          document.addEventListener('drawer:close', this.__onClose);
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          this.removeEventListener('click', this.__onClick);
          document.removeEventListener('drawer:level', this.__onLevel);
          document.removeEventListener('drawer:close', this.__onClose);
        }

        get isOpen() {
          return this.classList.contains('is-open');
        }

        get level() {
          return this.getAttribute('data-level') || '2';
        }

        open() {
          if (this.isOpen) return;
          this.setAttribute('data-open', 'true');
          this.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(() => {
            this.classList.add('is-open');
            /* Same focus rule as the level-1 drawer: focusing in the frame the
               class lands no-ops against the visibility transition's start
               value (hidden), so the drill panel never takes focus. Double
               rAF = first paint of the open state. */
            requestAnimationFrame(() => {
              if (this.isOpen && this.panel && typeof this.panel.focus === 'function') this.panel.focus();
            });
          });
        }

        close() {
          if (!this.isOpen) return;
          this.classList.remove('is-open');
          this.setAttribute('data-open', 'false');
          this.setAttribute('aria-hidden', 'true');
          this.__closeSublevels();
          this.__clearDrillState();
        }

        __sublevels() {
          return this.querySelectorAll('.nav-drawer-level2__sublevel');
        }

        __closeSublevels() {
          this.__sublevels().forEach(function (sub) {
            sub.classList.remove('is-open');
            sub.setAttribute('aria-hidden', 'true');
          });
        }

        __clearDrillState() {
          var drills = this.querySelectorAll('[data-nav-drill-child]');
          drills.forEach(function (button) {
            button.setAttribute('aria-expanded', 'false');
          });
        }

        __syncLevel(event) {
          var detail = (event && event.detail) || {};
          // Demo stages (data-static) are pinned open boards - they never
          // respond to live drawer events on the same page.
          if (this.hasAttribute('data-static')) return;
          var level = String(detail.level || '');
          if (level === '2') {
            if (detail.handle && this.getAttribute('data-category') !== detail.handle) return;
            this.__closeSublevels();
            this.open();
          } else if (level === '3') {
            if (detail.parent && this.getAttribute('data-category') !== detail.parent) return;
            var sub = this.querySelector(
              '[data-parent="' + this.getAttribute('data-category') + '"]#' +
              this.getAttribute('id') + '--' + (detail.handle || '')
            );
            if (sub) {
              sub.classList.add('is-open');
              sub.setAttribute('aria-hidden', 'false');
              var panel = sub.querySelector('.nav-drawer-level2__panel');
              /* Focus once the open state is actually painted: focusing in
                 the frame the class lands no-ops against the visibility
                 transition's start value (hidden). The sub-panel nests inside
                 a second transitioning wrapper (the sublevel), so a single
                 delayed attempt can still land early - retry per frame until
                 the focus sticks (10-frame cap bounds the loop). */
              var tries = 0;
              (function tryFocus() {
                if (!panel || typeof panel.focus !== 'function') return;
                if (document.activeElement !== panel && tries++ < 10) {
                  panel.focus();
                  requestAnimationFrame(tryFocus);
                }
              })();
            }
          } else {
            this.close();
          }
        }

        __handleClick(event) {
          var target = event.target;
          if (!target || !target.closest) return;
          var close = target.closest('[data-nav-drawer-close]');
          if (close) return; // the level-1 drawer element owns whole-drawer close
          var back = target.closest('[data-nav-back]');
          if (back) {
            event.preventDefault();
            var backLevel = back.getAttribute('data-nav-back-level') || '1';
            document.dispatchEvent(new CustomEvent('drawer:level', {
              detail: { level: Number(backLevel), handle: back.getAttribute('data-nav-back-handle') || '' }
            }));
            return;
          }
          var drill = target.closest('[data-nav-drill-child]');
          if (drill) {
            event.preventDefault();
            drill.setAttribute('aria-expanded', 'true');
            document.dispatchEvent(new CustomEvent('drawer:level', {
              detail: {
                level: 3,
                handle: drill.getAttribute('data-nav-handle') || '',
                parent: this.getAttribute('data-category') || ''
              }
            }));
          }
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nav-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('nav-drawer')) return;

    var TRANSITION_MS = 200;

    customElements.define(
      'nav-drawer',
      class NavDrawer extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.panel = this.querySelector('.nav-drawer__panel');
          this.__invoker = null;
          this.__onClick = this.__handleClick.bind(this);
          this.__onKeydown = this.__handleKeydown.bind(this);
          this.__onFocusIn = this.__trapFocus.bind(this);
          this.__onScrim = this.close.bind(this, false);
          this.__onLevel = this.__syncLevel.bind(this);
          this.__onOtherOverlay = this.close.bind(this, false);
          this.addEventListener('click', this.__onClick);
          this.addEventListener('focusin', this.__onFocusIn);
          document.addEventListener('click', this.__onClick);
          document.addEventListener('keydown', this.__onKeydown);
          document.addEventListener('scrim:click', this.__onScrim);
          document.addEventListener('drawer:level', this.__onLevel);
          document.addEventListener('header:search:open', this.__onOtherOverlay);
          document.addEventListener('header:cart:open', this.__onOtherOverlay);
          document.addEventListener('cart:open', this.__onOtherOverlay);
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          this.removeEventListener('click', this.__onClick);
          this.removeEventListener('focusin', this.__onFocusIn);
          document.removeEventListener('click', this.__onClick);
          document.removeEventListener('keydown', this.__onKeydown);
          document.removeEventListener('scrim:click', this.__onScrim);
          document.removeEventListener('drawer:level', this.__onLevel);
          document.removeEventListener('header:search:open', this.__onOtherOverlay);
          document.removeEventListener('header:cart:open', this.__onOtherOverlay);
          document.removeEventListener('cart:open', this.__onOtherOverlay);
        }

        get isOpen() {
          return this.classList.contains('is-open');
        }

        open(invoker) {
          if (this.isOpen) return;
          if (invoker) this.__invoker = invoker;
          this.classList.remove('is-closing');
          this.setAttribute('data-open', 'true');
          this.setAttribute('data-level', '1');
          this.setAttribute('aria-hidden', 'false');
          this.__clearDrillState();
          this.__scrollLock(true);
          this.__showScrim();
          requestAnimationFrame(() => {
            this.classList.add('is-open');
            /* Panel focus must wait until the visibility transition has
               actually made the panel focusable: focusing inside the same
               frame the class lands on the panel silently no-ops (computed
               visibility is still the transition's start value, hidden), the
               trap never engages and keyboard focus stays on the page behind
               the open drawer. Double rAF = first paint of the open state. */
            requestAnimationFrame(() => {
              if (this.isOpen && this.panel && typeof this.panel.focus === 'function') this.panel.focus();
            });
          });
          document.dispatchEvent(new CustomEvent('drawer:open'));
        }

        close(returnFocus) {
          if (!this.isOpen) return;
          this.classList.remove('is-open');
          this.classList.add('is-closing');
          this.setAttribute('data-open', 'false');
          this.setAttribute('aria-hidden', 'true');
          this.__scrollLock(false);
          this.__hideScrim();
          window.setTimeout(() => {
            if (!this.isOpen) this.classList.remove('is-closing');
          }, TRANSITION_MS);
          document.dispatchEvent(new CustomEvent('drawer:close'));
          if (returnFocus !== false && this.__invoker && typeof this.__invoker.focus === 'function') {
            this.__invoker.focus();
            this.__invoker = null;
          }
        }

        __handleClick(event) {
          var target = event.target;
          if (!target || !target.closest) return;
          var opener = target.closest('[data-nav-drawer-open]');
          if (opener) {
            event.preventDefault();
            this.open(opener);
            return;
          }
          if (!this.isOpen) return;
          if (target.closest('[data-nav-drawer-close]')) {
            this.close();
            return;
          }
          var drill = target.closest('[data-nav-drill]');
          if (drill) {
            event.preventDefault();
            this.__drill(drill);
          }
        }

        __drill(button) {
          button.setAttribute('aria-expanded', 'true');
          var detail = {
            level: 2,
            handle: button.getAttribute('data-nav-handle') || ''
          };
          document.dispatchEvent(new CustomEvent('drawer:level', { detail: detail }));
        }

        __syncLevel(event) {
          var detail = (event && event.detail) || {};
          var level = detail.level;
          if (level === 2 || level === '2') {
            this.setAttribute('data-level', '2');
          } else if (level === 3 || level === '3') {
            this.setAttribute('data-level', '3');
          } else {
            this.setAttribute('data-level', '1');
            this.__clearDrillState();
          }
        }

        __clearDrillState() {
          var drills = this.querySelectorAll('[data-nav-drill]');
          drills.forEach(function (button) {
            button.setAttribute('aria-expanded', 'false');
          });
        }

        __handleKeydown(event) {
          if (!this.isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (event.key !== 'Tab') return;
          var focusables = this.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          var list = Array.prototype.filter.call(focusables, (el) => el.offsetParent !== null);
          if (!list.length) return;
          var first = list[0];
          var last = list[list.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        __trapFocus() {
          if (!this.isOpen) return;
          var focusables = this.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          var list = Array.prototype.filter.call(focusables, (el) => el.offsetParent !== null);
          if (!list.length) return;
          if (!this.contains(document.activeElement)) {
            list[0].focus();
          }
        }

        __scrollLock(locked) {
          document.documentElement.style.overflow = locked ? 'hidden' : '';
          document.body.style.overflow = locked ? 'hidden' : '';
          if (locked) {
            document.body.setAttribute('data-drawer-open', '');
          } else {
            document.body.removeAttribute('data-drawer-open');
          }
        }

        __showScrim() {
          var scrim = document.querySelector('[data-scrim]');
          if (!scrim) return;
          scrim.style.setProperty('--scrim-top', '0px');
          scrim.classList.add('is-open');
        }

        __hideScrim() {
          var scrim = document.querySelector('[data-scrim]');
          if (!scrim) return;
          scrim.classList.remove('is-open');
          scrim.style.removeProperty('--scrim-top');
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["no-results"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('no-results-suggestions')) {
  customElements.define(
    'no-results-suggestions',
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loading) return;
        this.dataset.loading = 'true';
        this.fetchSuggestions();
      }

      disconnectedCallback() {
        delete this.dataset.loading;
      }

      fetchSuggestions() {
        var query = (this.getAttribute('data-query') || '').trim();
        var config = window.__noResultsRoutes || {};
        if (!query) {
          this.remove();
          return;
        }

        var base = config.predictiveSearchUrl || '/search/suggest.json';
        fetch(base + '?q=' + encodeURIComponent(query) + '&resources[type]=queries&resources[limit]=3')
          .then(function (response) {
            return response.json();
          })
          .then((data) => {
            var resources = (data.resources && data.resources.results) || data.resources || data;
            var queries = (resources.queries || [])
              .map(function (item) {
                return typeof item === 'string' ? item : item.text;
              })
              .filter(Boolean)
              .slice(0, 3);

            if (!queries.length) {
              this.remove();
              return;
            }

            var strings = window.__noResultsStrings || {};
            var searchBase = (config.searchUrl || '/search') + '?q=';

            this.classList.add('no-results__suggestions');
            this.textContent = '';

            var prefix = document.createElement('span');
            prefix.className = 'no-results__suggestions-prefix';
            prefix.textContent = strings.didYouMean || '';
            this.appendChild(prefix);

            queries.forEach((text, index) => {
              var item = document.createElement('span');
              item.className = 'no-results__suggestion';

              var link = document.createElement('a');
              link.className = 'no-results__suggestion-link';
              link.href = searchBase + encodeURIComponent(text);
              link.textContent = text;
              item.appendChild(link);

              if (index < queries.length - 1) {
                var separator = document.createElement('span');
                separator.className = 'no-results__suggestion-sep';
                separator.setAttribute('aria-hidden', 'true');
                separator.textContent = ',';
                item.appendChild(separator);
              }

              this.appendChild(item);
            });
          })
          .catch(() => {
            this.remove();
          });
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["notify-me"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('notify-me')) {
    customElements.define(
      'notify-me',
      class NotifyMe extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;

          this.form = this.querySelector('[data-notify-me-form]');
          /* form-input paints its `attributes` param on the .field wrapper,
             not the control -- resolve the real email input from there. */
          this.input = this.querySelector('[data-notify-me-email] .field__input') ||
            this.querySelector('[data-notify-me-email]');
          this.submitBtn = this.querySelector('[data-notify-me-submit]');
          this.field = this.querySelector('.notify-me__field');
          this.live = this.querySelector('[data-notify-me-live]');
          this.endpoint = this.getAttribute('data-notify-me-endpoint') || '';
          /* the | t filter HTML-escapes its output (apostrophes become
             &#39;), which leaks into a JS string literal -- decode through
             a detached textarea so the success line reads "we'll". */
          this.strings = {};
          const raw = window.__notifyMeStrings || {};
          const decoder = document.createElement('textarea');
          for (const key of Object.keys(raw)) {
            decoder.innerHTML = raw[key];
            this.strings[key] = decoder.value;
          }

          this.__onSubmit = (event) => this.handleSubmit(event);
          this.__onInput = () => {
            if (this.getAttribute('data-state') === 'error') this.sync('idle');
          };
          this.__onAnchor = (event) => this.handleAnchor(event);

          this.form.addEventListener('submit', this.__onSubmit);
          this.input.addEventListener('input', this.__onInput);
          document.addEventListener('click', this.__onAnchor);

          this.sync(this.getAttribute('data-state') || 'idle');
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          this.form.removeEventListener('submit', this.__onSubmit);
          this.input.removeEventListener('input', this.__onInput);
          document.removeEventListener('click', this.__onAnchor);
        }

        /* Sticky-bar contract: the mobile CTA scrolls to #notify-me, this
           panel owns the arrival focus. One delegated handler, one owner. */
        handleAnchor(event) {
          const trigger = event.target.closest(
            '[data-notify-me-trigger], a[href="#notify-me"]'
          );
          if (!trigger || !this.isConnected) return;
          if (this.__anchorTimer) clearTimeout(this.__anchorTimer);
          this.__anchorTimer = setTimeout(() => {
            this.input.focus({ preventScroll: true });
          }, 450);
        }

        sync(state, message) {
          this.setAttribute('data-state', state);

          if (state === 'error') {
            this.field.classList.add('field--error');
            this.input.setAttribute('aria-invalid', 'true');
            this.live.textContent =
              message || this.strings.error_generic || this.strings.error_invalid || '';
            return;
          }

          this.field.classList.remove('field--error');
          this.input.removeAttribute('aria-invalid');

          if (state === 'submitting') {
            this.submitBtn.classList.add('is-loading');
            this.submitBtn.setAttribute('aria-busy', 'true');
            this.submitBtn.disabled = true;
            return;
          }

          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.removeAttribute('aria-busy');
          this.submitBtn.disabled = false;

          if (state === 'success') {
            this.form.hidden = true;
            this.live.textContent = this.strings.success || '';
            this.live.setAttribute('tabindex', '-1');
            this.live.focus();
            return;
          }

          this.form.hidden = false;
          this.live.textContent = '';
        }

        handleSubmit(event) {
          event.preventDefault();
          if (this.getAttribute('data-state') === 'submitting') return;

          if (!this.input.checkValidity()) {
            this.sync('error', this.strings.error_invalid);
            return;
          }

          this.sync('submitting');

          const url = this.endpoint || this.form.getAttribute('action');
          fetch(url, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { Accept: 'text/html' }
          })
            .then((response) => {
              if (!response.ok) throw new Error('notify-me: ' + response.status);
              this.sync('success');
              document.dispatchEvent(
                new CustomEvent('notify-me:submitted', {
                  detail: {
                    product_id: this.getAttribute('data-product-id'),
                    variant_id: this.getAttribute('data-variant-id'),
                    email: this.input.value
                  }
                })
              );
            })
            .catch(() => {
              this.form.submit();
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["order-summary"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('order-summary')) return;

    var REFRESH_EVENT = 'cart:updated';

    function sectionIdFor(root) {
      if (window.__orderSummarySectionId) return window.__orderSummarySectionId;
      var sectionEl = root.closest('.shopify-section');
      return sectionEl && sectionEl.id
        ? sectionEl.id.replace(/^shopify-section-/, '')
        : null;
    }

    function swapSection(root) {
      var sectionId = sectionIdFor(root);
      if (!sectionId) return Promise.resolve();
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      return fetch(base + '?sections=' + encodeURIComponent(sectionId))
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var html = data && data[sectionId];
          if (!html) return;
          var tpl = document.createElement('template');
          tpl.innerHTML = html.trim();
          var fresh = tpl.content.querySelector('order-summary[data-order-summary]');
          if (fresh && root.parentNode) root.parentNode.replaceChild(fresh, root);
        })
        .catch(function () {});
    }

    class OrderSummary extends HTMLElement {
      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.__onCartUpdated = this.__handleCartUpdated.bind(this);
        document.addEventListener(REFRESH_EVENT, this.__onCartUpdated);
      }

      disconnectedCallback() {
        if (!this.__bound) return;
        document.removeEventListener(REFRESH_EVENT, this.__onCartUpdated);
        this.__bound = false;
      }

      __handleCartUpdated(event) {
        var self = this;
        if (self.hasAttribute('aria-busy')) return;
        self.setAttribute('aria-busy', 'true');
        swapSection(self).then(function () {
          // The swap replaces this element; if it survived (no section id)
          // drop the busy flag here. A replaced element is inert.
          if (self.isConnected) self.removeAttribute('aria-busy');
        });
      }
    }

    customElements.define('order-summary', OrderSummary);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-toc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('page-toc')) {
    customElements.define(
      'page-toc',
      class PageToc extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;

          this.list = this.querySelector('[data-page-toc-list]');
          this.selector = this.getAttribute('data-page-toc-content-selector') || '.page-prose';

          this.build();

          this.__onSectionLoad = () => this.build();

          document.addEventListener('shopify:section:load', this.__onSectionLoad);
          window.addEventListener('hashchange', this.__onHashChange = () => this.syncFromHash());
          this.spy = null;
          this.observeHeadings();
          this.syncFromHash();
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          document.removeEventListener('shopify:section:load', this.__onSectionLoad);
          window.removeEventListener('hashchange', this.__onHashChange);
          if (this.spy) this.spy.disconnect();
        }

        /* Slugify a heading's text the way handleize would: lowercase, strip
           tags, collapse non-alphanumerics to hyphens. */
        slugify(text) {
          return text
            .toLowerCase()
            .replace(/<[^>]*>/g, '')
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        }

        build() {
          if (!this.list) return;
          const prose = document.querySelector(this.selector);
          if (!prose) return;

          const headings = Array.from(prose.querySelectorAll('h2'));
          this.headings = headings;

          this.list.textContent = '';

          headings.forEach((heading, index) => {
            if (!heading.id) heading.id = this.slugify(heading.textContent) || ('page-toc-' + (index + 1));
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.className = 'page-toc__link';
            a.href = '#' + heading.id;
            a.textContent = heading.textContent.trim();
            li.appendChild(a);
            this.list.appendChild(li);
          });

          this.observeHeadings();
        }

        observeHeadings() {
          if (this.spy) this.spy.disconnect();
          if (!this.headings || !this.headings.length || !('IntersectionObserver' in window)) return;

          this.spy = new IntersectionObserver(
            (entries) => {
              /* Pick the entry nearest the top of the viewport that is
                 intersecting; keeps exactly one active link at any scroll. */
              const visible = entries
                .filter((entry) => entry.isIntersecting)
                .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
              if (visible.length) this.setActive(visible[0].target.id);
            },
            { rootMargin: '-80px 0px -60% 0px', threshold: 0 }
          );
          this.headings.forEach((h) => this.spy.observe(h));
        }

        setActive(id) {
          this.querySelectorAll('.page-toc__link').forEach((link) => {
            const isActive = link.getAttribute('href') === '#' + id;
            link.classList.toggle('page-toc__link--active', isActive);
            if (isActive) {
              link.setAttribute('aria-current', 'true');
            } else {
              link.removeAttribute('aria-current');
            }
          });
        }

        syncFromHash() {
          if (window.location.hash) {
            const id = decodeURIComponent(window.location.hash.slice(1));
            if (this.querySelector('[href="#' + id + '"]')) this.setActive(id);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pair-it-with"] && !Shopify.designMode) return;
  try {
    (function () {
      if (window.__pairItWithInit) return;
      window.__pairItWithInit = true;

      var ROUTES = window.__pairItWithRoutes || {};

      document.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-pair-it-with-form]');
        if (!form) return;
        event.preventDefault();

        var button = form.querySelector('[data-pair-it-with-add]');
        if (!button || button.hasAttribute('data-busy')) return;
        button.setAttribute('data-busy', '');

        fetch(ROUTES.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: new URLSearchParams(new FormData(form))
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            return response.json();
          })
          .then(function () {
            button.removeAttribute('data-busy');
            document.dispatchEvent(new CustomEvent('cart:add', { detail: { invoker: button } }));
          })
          .catch(function () {
            button.removeAttribute('data-busy');
            form.submit();
          });
      });
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productCardInit) return;
    window.__productCardInit = true;

    var STRINGS = window.__productCardStrings || {};
    var ROUTES = window.__productCardRoutes || {};

    function setState(card, state) {
      card.removeAttribute('data-adding');
      card.removeAttribute('data-added');
      card.removeAttribute('data-sold-out');
      if (state) card.setAttribute('data-' + state, 'true');
    }

    function addToCart(form, card, invoker) {
      setState(card, 'adding');

      var formData = new FormData(form);
      var body = new URLSearchParams(formData);
      body.append('sections', '');

      fetch(ROUTES.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: body
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () {
          setState(card, 'added');
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { variant_id: formData.get('id'), quantity: 1 }
          }));
          document.dispatchEvent(new CustomEvent('cart:add', {
            detail: { invoker: invoker }
          }));
          window.setTimeout(function () {
            setState(card, null);

            /* Adding from the wishlist takes the item off the list (Kate,
               10 Sep 2026: "once an item is added to bag this item is removed
               from wishlist"). It runs on the existing 2s beat rather than
               immediately, so the shopper sees "Added" before the card goes -
               removing on the instant would drop the card mid-confirmation.
               Scoped by the remove control's presence, which only the
               wishlist_actions row renders: adding from a collection grid or
               a rail must never clear a saved item. api.remove publishes, so
               the wishlist page re-renders and the card leaves on its own. */
            var wlRemove = card.querySelector('.product-card__actions-remove[data-wishlist-handle]');
            if (wlRemove && window.__wishlist) {
              window.__wishlist.remove(wlRemove.getAttribute('data-wishlist-handle'));
            }
          }, 2000);
        })
        .catch(function () {
          setState(card, null);
          window.location.href = ROUTES.cart || '/cart';
        });
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-quick-add-form]');
      if (!form) return;
      event.preventDefault();
      /* data-quick-add-host: the flyout's compact rows reuse this add path. */
      var card = form.closest('.product-card, [data-quick-add-host]');
      if (card) addToCart(form, card, event.submitter || form.querySelector('[data-quick-add]'));
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-add-trigger]');
      if (!trigger) return;
      var card = trigger.closest('.product-card');
      if (!card) return;
      var form = card.querySelector('[data-quick-add-form]');
      if (form) addToCart(form, card, trigger);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('product-gallery')) return;

    class ProductGallery extends HTMLElement {
      connectedCallback() {
        if (this.__pgBound) return;
        this.__pgBound = true;

        this.__track = this.querySelector('[data-gallery-track]');
        this.__slides = this.querySelectorAll('[data-gallery-slide]');
        this.__dots = this.querySelectorAll('[data-gallery-dot]');
        this.__thumbs = this.querySelectorAll('[data-gallery-thumb]');
        this.__expand = this.querySelector('[data-gallery-expand]');
        this.__badge = this.querySelector('[data-gallery-badge]');

        this.__onDotClick = this.onDotClick.bind(this);
        this.__onScroll = this.onScroll.bind(this);
        this.__onExpand = this.onExpand.bind(this);
        this.__onVariantChange = this.onVariantChange.bind(this);

        if (this.__badge) {
          document.addEventListener('product:variant-change', this.__onVariantChange);
        }

        if (this.__expand) {
          this.__expand.addEventListener('click', this.__onExpand);
        }

        if (this.__track && this.__dots.length > 1) {
          /* Bind unconditionally - the dots are display:none on desktop,
             so a desktop bind costs nothing and a resize to mobile keeps
             them working without a re-connect. */
          this.__track.addEventListener('scroll', this.__onScroll, { passive: true });

          if ('IntersectionObserver' in window) {
            this.__observer = new IntersectionObserver(this.onIntersect.bind(this), {
              root: this.__track,
              threshold: 0.6
            });
            this.__slides.forEach(function (slide) {
              this.__observer.observe(slide);
            }, this);
          }
        }
      }

      disconnectedCallback() {
        if (!this.__pgBound) return;
        this.__pgBound = false;
        if (this.__expand) this.__expand.removeEventListener('click', this.__onExpand);
        document.removeEventListener('product:variant-change', this.__onVariantChange);
        if (this.__track) this.__track.removeEventListener('scroll', this.__onScroll);
        if (this.__observer) {
          this.__observer.disconnect();
          this.__observer = null;
        }
      }

      onVariantChange(event) {
        var detail = event.detail || {};
        var badge = this.__badge;
        if (!badge) return;
        var price = Number(detail.price) || 0;
        var compare = Number(detail.compare_at_price) || 0;
        var percent = compare > price ? Math.round(((compare - price) * 100) / compare) : 0;
        if (percent > 0) {
          var label = badge.querySelector('.sale-badge');
          var template = badge.getAttribute('data-percent-template') || '';
          if (label && template) label.textContent = template.replace('__percent__', percent);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }

      onDotClick(event) {
        var dot = event.target.closest('[data-gallery-dot]');
        if (!dot) return;
        var index = parseInt(dot.getAttribute('data-slide-index'), 10);
        var slide = this.__slides[index];
        if (!slide) return;

        /* Dots are buttons for keyboard parity; clicking one scrolls the
           scroller to the slide. Hidden attribute never applies to the
           first initial_count slides, so desktop clicks are no-ops. */
        slide.scrollIntoView({
          behavior: this.reducedMotion() ? 'auto' : 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      }

      onThumbClick(event) {
        var thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        var index = parseInt(thumb.getAttribute('data-slide-index'), 10);
        this.setCurrent(index);
      }

      /* Desktop main-image swap (checklist 4): is-current picks the slide
         the main stage shows; the thumbs mirror it with is-active. Mobile
         ignores is-current (every slide is a scroller child there). */
      setCurrent(index) {
        this.__slides.forEach(function (slide) {
          var slideIndex = parseInt(slide.getAttribute('data-slide-index'), 10);
          slide.classList.toggle('is-current', slideIndex === index);
        });
        this.__thumbs.forEach(function (thumb) {
          var thumbIndex = parseInt(thumb.getAttribute('data-slide-index'), 10);
          var isActive = thumbIndex === index;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      onScroll() {
        var self = this;
        if (this.__scrollTimer) window.clearTimeout(this.__scrollTimer);
        this.__scrollTimer = window.setTimeout(function () {
          self.settleActive();
        }, 120);
      }

      onIntersect(entries) {
        var self = this;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var index = parseInt(entry.target.getAttribute('data-slide-index'), 10);
            self.setActive(index);
          }
        });
      }

      settleActive() {
        var track = this.__track;
        if (!track) return;
        var trackLeft = track.getBoundingClientRect().left;
        var best = 0;
        var bestDistance = Infinity;

        this.__slides.forEach(function (slide) {
          if (slide.offsetParent === null) return;
          var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = parseInt(slide.getAttribute('data-slide-index'), 10);
          }
        });

        this.setActive(best);
      }

      setActive(index) {
        var self = this;
        this.__dots.forEach(function (dot) {
          var dotIndex = parseInt(dot.getAttribute('data-slide-index'), 10);
          var isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      onExpand() {
        var extras = this.querySelectorAll('[data-gallery-extra]');
        extras.forEach(function (figure) {
          figure.removeAttribute('data-gallery-extra');
          figure.removeAttribute('hidden');
        });
        this.setAttribute('data-expanded', 'true');
        if (this.__expand) {
          this.__expand.setAttribute('aria-expanded', 'true');
          this.__expand.hidden = true;
        }
        document.dispatchEvent(new CustomEvent('gallery:expanded', {
          detail: { gallery: this }
        }));
      }
    }

    customElements.define('product-gallery', ProductGallery);

    /* Dot and thumb clicks delegate at document level exactly once (one
       owner per trigger) so Section Rendering swaps never double-bind; the
       custom element instance resolves from the closest gallery root. */
    if (!window.__productGalleryDotsInit) {
      window.__productGalleryDotsInit = true;

      document.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-gallery-dot]');
        if (dot) {
          var dotGallery = dot.closest('product-gallery');
          if (dotGallery && typeof dotGallery.onDotClick === 'function') {
            dotGallery.onDotClick(event);
          }
          return;
        }

        var thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        var gallery = thumb.closest('product-gallery');
        if (!gallery || typeof gallery.onThumbClick !== 'function') return;
        gallery.onThumbClick(event);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-stepper"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-stepper')) {
    customElements.define(
      'quantity-stepper',
      class QuantityStepper extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.input = this.querySelector('[data-stepper-input]');
          this.minusBtn = this.querySelector('[data-stepper-minus]');
          this.plusBtn = this.querySelector('[data-stepper-plus]');
          this.__onMinus = () => this.step(-1);
          this.__onPlus = () => this.step(1);
          this.__onInput = () => this.__sync();
          this.__onChange = () => this.__commit(true);
          this.__onBlur = () => this.__commit();
          this.minusBtn.addEventListener('click', this.__onMinus);
          this.plusBtn.addEventListener('click', this.__onPlus);
          this.input.addEventListener('input', this.__onInput);
          this.input.addEventListener('change', this.__onChange);
          this.input.addEventListener('blur', this.__onBlur);
          this.__sync();
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          this.minusBtn.removeEventListener('click', this.__onMinus);
          this.plusBtn.removeEventListener('click', this.__onPlus);
          this.input.removeEventListener('input', this.__onInput);
          this.input.removeEventListener('change', this.__onChange);
          this.input.removeEventListener('blur', this.__onBlur);
        }

        get value() {
          const parsed = parseInt(this.input.value, 10);
          return Number.isNaN(parsed) ? this.min : parsed;
        }

        get min() {
          const parsed = parseInt(this.input.min, 10);
          return Number.isNaN(parsed) ? 1 : parsed;
        }

        get max() {
          const parsed = parseInt(this.input.max, 10);
          return Number.isNaN(parsed) ? 0 : parsed;
        }

        step(delta) {
          this.__set(this.value + delta);
          this.__publish();
        }

        __set(next) {
          let clamped = next;
          if (clamped < this.min) clamped = this.min;
          const max = this.max;
          if (max && clamped > max) clamped = max;
          this.input.value = clamped;
          this.__sync();
          return clamped;
        }

        __commit(fromChangeEvent) {
          // __publish re-dispatches `change` on the input, and the input's own
          // change listener is __commit - publishing `change` from a
          // change-originated commit re-enters itself and recursed until the
          // stack blew. So the two signals are separated: the input's real
          // `change` event carries the settle on its own path (never
          // re-dispatched), while the composed `quantity:change` fires on
          // every settle path - except inside __publish's own change dispatch,
          // which already announced. On blur, `change` is additionally
          // published when clamping altered the value: the UA's change, where
          // one fires, carried the pre-clamp value and hosts must be corrected.
          const before = this.input.value;
          this.__set(this.value);
          const clamped = this.input.value !== before;
          if (this.__publishing) {
            // Our own synthetic change from __publish - already announced.
            return;
          }
          if (fromChangeEvent) {
            this.__announce();
          } else if (clamped) {
            this.__publish();
          } else {
            this.__announce();
          }
        }

        __announce() {
          // Coalesce settle bursts: a single user action can emit change +
          // blur + a clamped publish, and some UAs fire the native change
          // right after the blur commit. Hosts need one quantity:change per
          // settled VALUE, so skip re-announcing an unchanged value.
          if (this.__announcedValue === this.value) return;
          this.__announcedValue = this.value;
          this.dispatchEvent(
            new CustomEvent('quantity:change', {
              bubbles: true,
              composed: true,
              detail: { value: this.value },
            })
          );
        }

        __publish() {
          this.__publishing = true;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          this.__publishing = false;
          this.__announce();
        }

        __sync() {
          this.minusBtn.disabled = this.value <= this.min;
          const max = this.max;
          this.plusBtn.disabled = Boolean(max) && this.value >= max;
          this.input.setAttribute('aria-valuenow', String(this.value));
          this.input.setAttribute('aria-valuemin', String(this.min));
          if (max) this.input.setAttribute('aria-valuemax', String(max));
          else this.input.removeAttribute('aria-valuemax');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scrim"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__scrimClick) return;
    window.__scrimClick = true;
    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;
      var scrim = event.target.closest('[data-scrim]');
      if (!scrim) return;
      document.dispatchEvent(new CustomEvent('scrim:click', { bubbles: true }));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-add-bar')) {
    customElements.define(
      'sticky-add-bar',
      class StickyAddBar extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;

          this.__strings = window.__stickyAddBarStrings || {};
          this.__priceEl = this.querySelector('.sticky-add-bar__price');

          this.__variants = [];
          var dataEl = this.querySelector('[data-sticky-add-bar-data]');
          try {
            this.__variants = JSON.parse(dataEl ? dataEl.textContent : '[]');
          } catch (err) {
            this.__variants = [];
          }

          this.__onVariant = (event) => this.handleVariantChange(event.detail);
          this.__onSubmit = (event) => {
            var form = event.target;
            if (form && form.id === this.getAttribute('data-form-id')) this.setBusy(true);
          };
          this.__onAdded = () => this.setBusy(false);
          this.__onClick = (event) => this.handleClick(event);

          document.addEventListener('product:variant-change', this.__onVariant);
          document.addEventListener('submit', this.__onSubmit);
          document.addEventListener('cart:item-added', this.__onAdded);
          this.addEventListener('click', this.__onClick);

          var watchSel = this.getAttribute('data-watch');
          if (watchSel === 'none') {
            this.syncVisible(this.getAttribute('data-visible') === 'true');
          } else {
            var target = document.querySelector(watchSel || '[data-buy-box-atc]');
            if (target && typeof IntersectionObserver === 'function') {
              this.__observer = new IntersectionObserver((entries) => {
                for (const entry of entries) this.syncVisible(!entry.isIntersecting);
              });
              this.__observer.observe(target);
            } else {
              this.syncVisible(false);
            }
          }
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;

          if (this.__observer) {
            this.__observer.disconnect();
            this.__observer = null;
          }
          document.removeEventListener('product:variant-change', this.__onVariant);
          document.removeEventListener('submit', this.__onSubmit);
          document.removeEventListener('cart:item-added', this.__onAdded);
          this.removeEventListener('click', this.__onClick);
          if (this.__busyTimer) clearTimeout(this.__busyTimer);
          document.documentElement.style.removeProperty('--sticky-add-bar-height');
        }

        syncVisible(visible) {
          this.setAttribute('data-visible', visible ? 'true' : 'false');
          if (visible) {
            this.removeAttribute('inert');
            document.documentElement.style.setProperty('--sticky-add-bar-height', '64px');
          } else {
            this.setAttribute('inert', '');
            document.documentElement.style.removeProperty('--sticky-add-bar-height');
          }
        }

        setBusy(busy) {
          var add = this.querySelector('[data-sticky-add-bar-add]');
          if (!add) return;

          if (this.__busyTimer) {
            clearTimeout(this.__busyTimer);
            this.__busyTimer = null;
          }

          if (busy) {
            add.disabled = true;
            add.setAttribute('aria-busy', 'true');
            /* safety net: never wedge the button if no cart event arrives */
            this.__busyTimer = setTimeout(() => this.setBusy(false), 4000);
          } else {
            add.disabled = false;
            add.removeAttribute('aria-busy');
          }
        }

        handleClick(event) {
          var notify = event.target.closest('[data-sticky-add-bar-notify]');
          if (!notify || notify.hidden) return;

          var panel = document.getElementById(
            this.getAttribute('data-notify-target') || 'notify-me'
          );
          if (!panel) return;

          event.preventDefault();
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          /* the notify-me panel owns the arrival focus (its data-notify-me-trigger contract) */
        }

        handleVariantChange(detail) {
          if (!detail) return;

          var variant = null;
          for (var i = 0; i < this.__variants.length; i++) {
            if (String(this.__variants[i].id) === String(detail.variant_id)) {
              variant = this.__variants[i];
              break;
            }
          }

          var available = detail.available !== undefined ? detail.available : (variant ? variant.available : true);
          var sale = Number(detail.compare_at_price || 0) > Number(detail.price || 0);
          this.classList.toggle('sticky-add-bar--sale', sale);

          if (this.__priceEl) {
            var current = this.__priceEl.querySelector('.price__current');
            var compare = this.__priceEl.querySelector('.price__compare');
            if (current) current.textContent = variant ? variant.price_money : (detail.price ? '$' + (detail.price / 100).toFixed(2) : current.textContent);
            if (sale) {
              if (!compare) {
                compare = document.createElement('s');
                compare.className = 'price__compare';
                var sr = document.createElement('span');
                sr.className = 'price__sr';
                sr.textContent = this.__strings.regularPrice || '';
                compare.appendChild(sr);
                this.__priceEl.appendChild(compare);
              }
              compare.textContent = '';
              compare.appendChild(document.createTextNode((variant && variant.compare_money) ? variant.compare_money : (detail.compare_at_price ? '$' + (detail.compare_at_price / 100).toFixed(2) : '')));
            } else if (compare) {
              compare.remove();
            }
            this.__priceEl.classList.toggle('price--sale', sale);
          }

          this.syncActions(available);
        }

        syncActions(available) {
          var add = this.querySelector('[data-sticky-add-bar-add]');
          var notify = this.querySelector('[data-sticky-add-bar-notify]');

          this.classList.toggle('sticky-add-bar--oos', !available);

          if (available) {
            if (add) add.hidden = false;
            if (notify) notify.hidden = true;
            if (this.getAttribute('data-state') !== 'gift') this.setAttribute('data-state', 'default');
          } else {
            if (add) add.hidden = true;
            if (notify) notify.hidden = false;
            this.setAttribute('data-state', 'oos');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__wishlist) return;

    var KEY = 'synergy:wishlist';

    function read() {
      try {
        var raw = window.localStorage.getItem(KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
      } catch (error) {
        /* Private mode / blocked storage: the control degrades to a no-op
           rather than throwing on every card render. */
        return [];
      }
    }

    function write(list) {
      try {
        window.localStorage.setItem(KEY, JSON.stringify(list));
      } catch (error) {
        /* ignore - see read() */
      }
    }

    function publish(handle, active) {
      var list = read();
      document.dispatchEvent(
        new CustomEvent('wishlist:updated', {
          detail: { handles: list, count: list.length, handle: handle, active: active }
        })
      );
    }

    var api = {
      get: read,
      has: function (handle) {
        return read().indexOf(handle) !== -1;
      },
      remove: function (handle) {
        var list = read().filter(function (h) { return h !== handle; });
        write(list);
        publish(handle, false);
        return false;
      },
      toggle: function (handle) {
        var list = read();
        var index = list.indexOf(handle);
        if (index === -1) {
          list.unshift(handle);
        } else {
          list.splice(index, 1);
        }
        write(list);
        var active = index === -1;
        publish(handle, active);
        return active;
      }
    };

    function paint(button) {
      var handle = button.getAttribute('data-wishlist-handle');
      if (!handle) return;
      var active = api.has(handle);
      var label = active
        ? button.getAttribute('data-label-remove')
        : button.getAttribute('data-label-add');
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (label) {
        button.setAttribute('aria-label', label);
        button.setAttribute('title', label);
      }
    }

    function paintCount() {
      var count = read().length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
        node.textContent = count > 0 ? String(count) : '';
        node.hidden = count === 0;
      });
      /* The badge is decorative; the count reaches assistive tech through the
         link's own name, matching how the bag control announces its count. */
      document.querySelectorAll('[data-wishlist-link]').forEach(function (link) {
        var template = link.getAttribute('data-label-template');
        if (count === 0 && link.getAttribute('data-label-zero')) {
          template = link.getAttribute('data-label-zero');
        } else if (count === 1 && link.getAttribute('data-label-template-one')) {
          template = link.getAttribute('data-label-template-one');
        }
        if (template) link.setAttribute('aria-label', template.replace('__COUNT__', String(count)));
        /* Header heart swaps to its filled drawing while the list has items. */
        if (count > 0) {
          link.setAttribute('data-wishlist-has-items', '');
        } else {
          link.removeAttribute('data-wishlist-has-items');
        }
      });
    }

    function paintAll(root) {
      (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(paint);
      /* Header badge is global - always repaint from the document, never the
         passed-in subtree. */
      paintCount();
    }

    /* Exposed so surfaces that inject cards (the wishlist page) can repaint
       the hearts they just added without re-entering the update event. */
    api.paint = paintAll;
    window.__wishlist = api;

    /* One delegated listener: buttons inside Section-Rendering swaps and
       load-more appends need no re-binding. */
    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-wishlist-toggle]') : null;
      if (!button) return;
      event.preventDefault();
      var handle = button.getAttribute('data-wishlist-handle');
      if (!handle) return;
      api.toggle(handle);
      paintAll();
    });

    document.addEventListener('wishlist:updated', function () { paintAll(); });
    document.addEventListener('shopify:section:load', function (event) { paintAll(event.target); });
    /* Another tab changed the list. */
    window.addEventListener('storage', function (event) {
      if (event.key === KEY) paintAll();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { paintAll(); });
    } else {
      paintAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["write-a-review"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('write-a-review')) return;

    var TRANSITION_MS = 300;

    customElements.define(
      'write-a-review',
      class WriteAReview extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.panel = this.querySelector('.write-a-review__panel');
          this.form = this.querySelector('[data-war-form]');
          this.successView = this.querySelector('[data-war-success]');
          this.stage = this.querySelector('[data-war-stage]');
          this.stars = Array.prototype.slice.call(this.querySelectorAll('[data-war-star]'));
          this.ratingError = this.querySelector('[data-war-error-rating]');
          this.submitBtn = this.querySelector('[data-war-submit]');
          this.__invoker = null;
          this.__rating = 0;
          this.__onClick = this.__handleClick.bind(this);
          this.__onKeydown = this.__handleKeydown.bind(this);
          this.__onScrim = this.close.bind(this, false);
          this.__onOpenEvent = this.open.bind(this, null);
          this.__onOtherOverlay = this.close.bind(this, false);
          this.__onFocusIn = this.__trapFocus.bind(this);
          this.__onHash = this.__handleHash.bind(this);
          this.__onSubmit = this.__handleSubmit.bind(this);
          this.addEventListener('focusin', this.__onFocusIn);
          document.addEventListener('click', this.__onClick);
          document.addEventListener('keydown', this.__onKeydown);
          document.addEventListener('scrim:click', this.__onScrim);
          document.addEventListener('review:write-open', this.__onOpenEvent);
          document.addEventListener('header:cart:open', this.__onOtherOverlay);
          document.addEventListener('drawer:open', this.__onOtherOverlay);
          document.addEventListener('cart:open', this.__onOtherOverlay);
          document.addEventListener('header:search:open', this.__onOtherOverlay);
          /* hashchange dispatches on window (it never bubbles to document,
             so a document listener never fires) */
          window.addEventListener('hashchange', this.__onHash);
          document.addEventListener('submit', this.__onSubmit);
          this.__handleHash();
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          this.removeEventListener('focusin', this.__onFocusIn);
          document.removeEventListener('click', this.__onClick);
          document.removeEventListener('keydown', this.__onKeydown);
          document.removeEventListener('scrim:click', this.__onScrim);
          document.removeEventListener('review:write-open', this.__onOpenEvent);
          document.removeEventListener('header:cart:open', this.__onOtherOverlay);
          document.removeEventListener('drawer:open', this.__onOtherOverlay);
          document.removeEventListener('cart:open', this.__onOtherOverlay);
          document.removeEventListener('header:search:open', this.__onOtherOverlay);
          document.removeEventListener('submit', this.__onSubmit);
          window.removeEventListener('hashchange', this.__onHash);
        }

        get isOpen() {
          return this.classList.contains('is-open');
        }

        open(invoker) {
          if (this.isOpen) return;
          /* the success view is terminal for one submission only: a re-open
             starts a fresh form rather than the previous thank-you */
          if (this.getAttribute('data-state') === 'success') this.__resetToForm();
          if (invoker) this.__invoker = invoker;
          this.classList.remove('is-closing');
          this.setAttribute('aria-hidden', 'false');
          this.__scrollLock(true);
          this.__showScrim();
          requestAnimationFrame(() => {
            this.classList.add('is-open');
            /* Focus must land after is-open flips visibility - focus() silently
               no-ops on a visibility:hidden panel (style recalc happens after
               this synchronous point), leaving focus on body. A second rAF
               guarantees the recalc, matching the cart-flyout fix. */
            requestAnimationFrame(() => this.__focusPanel());
          });
          /* single-drawer rule: close the other overlays (they subscribe) */
          document.dispatchEvent(new CustomEvent('review-drawer:open'));
          var expanded = document.querySelector('[data-pdp-reviews-trigger]');
          if (expanded) expanded.setAttribute('aria-expanded', 'true');
        }

        close(returnFocus) {
          if (!this.isOpen) return;
          this.classList.remove('is-open');
          this.classList.add('is-closing');
          this.setAttribute('aria-hidden', 'true');
          this.__scrollLock(false);
          this.__hideScrim();
          window.setTimeout(() => {
            if (!this.isOpen) this.classList.remove('is-closing');
          }, TRANSITION_MS);
          document.dispatchEvent(new CustomEvent('review-drawer:close'));
          document.dispatchEvent(new CustomEvent('review:write-close'));
          var expanded = document.querySelector('[data-pdp-reviews-trigger]');
          if (expanded) expanded.setAttribute('aria-expanded', 'false');
          if (returnFocus !== false && this.__invoker && typeof this.__invoker.focus === 'function') {
            this.__invoker.focus();
            this.__invoker = null;
          }
        }

        __handleClick(event) {
          var target = event.target;
          if (!target || !target.closest) return;
          var closeHit = target.closest('[data-war-close]');
          if (closeHit && this.contains(closeHit)) {
            this.close();
            return;
          }
          var star = target.closest('[data-war-star]');
          if (star && this.contains(star)) {
            this.__selectRating(parseInt(star.getAttribute('data-war-star'), 10));
            return;
          }
          if (!this.isOpen) return;
          var back = target.closest('[data-war-back]');
          if (back && this.contains(back)) {
            /* "Back to product" closes the drawer; no page navigation. The
               anchor's href stays as the no-JS fallback (product URL). */
            event.preventDefault();
            this.close();
          }
        }

        __handleKeydown(event) {
          if (!this.isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            var current = document.activeElement;
            var star = current && current.closest ? current.closest('[data-war-star]') : null;
            if (star && this.contains(star)) {
              event.preventDefault();
              var idx = parseInt(star.getAttribute('data-war-star'), 10);
              var next = event.key === 'ArrowRight' ? Math.min(5, idx + 1) : Math.max(1, idx - 1);
              var nextStar = this.querySelector('[data-war-star="' + next + '"]');
              if (nextStar) nextStar.focus();
            }
            return;
          }
          if (event.key !== 'Tab') return;
          var list = this.__visibleFocusables();
          if (!list.length) return;
          var first = list[0];
          var last = list[list.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        __handleHash() {
          var hash = (this.getAttribute('data-open-hash') || 'write-a-review');
          if (window.location.hash === '#' + hash) this.open(null);
        }

        __selectRating(value) {
          this.__rating = value;
          this.stars.forEach((star) => {
            var on = parseInt(star.getAttribute('data-war-star'), 10) <= value;
            star.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          this.__clearRatingError();
        }

        __clearRatingError() {
          if (this.ratingError) this.ratingError.hidden = true;
          if (this.stars.length) {
            this.stars[0].closest('[data-war-rating]').removeAttribute('data-invalid');
          }
        }

        __showRatingError() {
          if (this.ratingError) this.ratingError.hidden = false;
          if (this.stars.length) {
            this.stars[0].closest('[data-war-rating]').setAttribute('data-invalid', 'true');
          }
        }

        __handleSubmit(event) {
          var form = event.target;
          if (form !== this.form) return;
          event.preventDefault();
          if (this.getAttribute('data-state') === 'submitting') return;

          if (!this.__rating) {
            this.__showRatingError();
            return;
          }

          var endpoint = this.getAttribute('data-endpoint') || '';
          this.__setSubmitting(true);

          if (endpoint) {
            /* reviews-app contract: POST and resolve on the response */
            var body = new FormData(this.form);
            body.append('rating', String(this.__rating));
            fetch(endpoint, { method: 'POST', body: body, headers: { Accept: 'application/json' } })
              .then((response) => {
                if (!response.ok) throw new Error('write-a-review: ' + response.status);
                this.__setSuccess();
              })
              .catch(() => {
                this.__setSubmitting(false);
              });
            return;
          }

          /* No reviews app yet (manifest data_sources): the drawer is the
             skin spec - demonstrate the app contract locally, never navigate. */
          window.setTimeout(() => this.__setSuccess(), 600);
        }

        __setSubmitting(busy) {
          if (busy) {
            this.setAttribute('data-state', 'submitting');
            if (this.submitBtn) {
              this.submitBtn.classList.add('is-loading');
              this.submitBtn.setAttribute('aria-busy', 'true');
              this.submitBtn.disabled = true;
            }
            this.querySelectorAll('[data-war-field] input, [data-war-field] textarea, [data-war-photo]')
              .forEach((el) => { el.disabled = true; });
          } else {
            this.setAttribute('data-state', 'open');
            if (this.submitBtn) {
              this.submitBtn.classList.remove('is-loading');
              this.submitBtn.removeAttribute('aria-busy');
              this.submitBtn.disabled = false;
            }
            this.querySelectorAll('[data-war-field] input, [data-war-field] textarea, [data-war-photo]')
              .forEach((el) => { el.disabled = false; });
          }
        }

        __setSuccess() {
          this.setAttribute('data-state', 'success');
          if (this.submitBtn) {
            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.removeAttribute('aria-busy');
          }
          var formBody = this.querySelector('[data-war-form-body]');
          if (formBody) formBody.hidden = true;
          this.successView.hidden = false;
          /* the stage is the only scroll region: a submit from halfway down
             the form must not leave the thank-you scrolled out of view */
          if (this.stage) this.stage.scrollTop = 0;
          var title = this.successView.querySelector('.write-a-review__success-title');
          if (title) {
            title.setAttribute('tabindex', '-1');
            title.focus();
          }
        }

        __resetToForm() {
          if (this.successView) this.successView.hidden = true;
          var formBody = this.querySelector('[data-war-form-body]');
          if (formBody) formBody.hidden = false;
          this.querySelectorAll('[data-war-field] input, [data-war-field] textarea, [data-war-photo]')
            .forEach((el) => { el.value = ''; });
          this.__selectRating(0);
          /* restores data-state, the submit button and the field enabled
             state in one place (the not-busy branch) */
          this.__setSubmitting(false);
        }

        __focusPanel() {
          if (this.panel && typeof this.panel.focus === 'function') this.panel.focus();
        }

        __trapFocus(event) {
          var list = this.__visibleFocusables();
          if (!list.length) return;
          if (!this.contains(document.activeElement)) {
            list[0].focus();
          }
        }

        __visibleFocusables() {
          var focusables = this.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          return Array.prototype.filter.call(focusables, (el) => {
            if (el.offsetParent === null) return false;
            var node = el;
            while (node && node !== this) {
              if (node.hasAttribute && node.hasAttribute('hidden')) return false;
              node = node.parentNode;
            }
            return true;
          });
        }

        __scrollLock(locked) {
          document.documentElement.style.overflow = locked ? 'hidden' : '';
          document.body.style.overflow = locked ? 'hidden' : '';
        }

        __showScrim() {
          var scrim = document.querySelector('[data-scrim]');
          if (!scrim) return;
          scrim.style.setProperty('--scrim-top', '0px');
          scrim.classList.add('is-open');
        }

        __hideScrim() {
          var scrim = document.querySelector('[data-scrim]');
          if (!scrim) return;
          scrim.classList.remove('is-open');
          scrim.style.removeProperty('--scrim-top');
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
